import React, { useState, useEffect, Fragment, useRef  } from 'react';
import './utilities.scss';
import nxtds_icons from '../../dashIcon';
import { __ } from '@wordpress/i18n';
var plugin_url = nxtext_ajax_object.nxtex_url;
import { nxtdash_save_data, extraOptionsSave, nxtReplaceBtnClick, nxtAdobeFontGet, nxtRegenerateThumb, nxtdash_save_simplefont, nxtdash_save_variablefont } from '../../apicall';
import ProNotice from '../pro-model/pro-notice'
import ExtensionInstallPopup from '../extension_install_pop/ext_install_pop'

let proAct = (nxtext_ajax_object?.dashData?.activePlan) ? true : false;
let extensionInstall = (nxtext_ajax_object?.dashData?.extensioninstall) ? true : false;

var SettingData = [
    {
        key: 'adobe-font',
        name: __('Adobe Fonts', 'nexter-extension'),
        popDesc: __('Connect your Adobe Typekit project ID to use Adobe fonts on your website.', 'nexter-extension'),
        formField: { key: 'adobe-font', label: __('Project ID', 'nexter-extension') },
        doclink: 'https://nexterwp.com/help/nexter-extension/adobe-fonts-extra-options/'
    },
    {
        key: 'custom-upload-font',
        name: __('Custom Fonts Upload', 'nexter-extension'),
        popDesc: __('Upload your custom fonts and use them on your website to give a unique look to your website.', 'nexter-extension'),
        formField: { key: 'custom-upload-font', label: __('adobe scan', 'nexter-extension') },
        doclink: 'https://nexterwp.com/help/nexter-extension/custom-fonts-upload-extra-options/'
    },
    {
        key: 'smtp-email',
        name: __('SMTP Email', 'nexter-extension'),
        popDesc: __('Use Google SMTP or a Custom SMTP to ensure your site’s emails are delivered to inboxes reliably.', 'nexter-extension'),
        doclink : 'https://nexterwp.com/help/nexter-extension/setup-smtp-in-wordpress/',
        formField: { key: 'smtp-email', label: __('SMTP Email', 'nexter-extension') },
        isBeta : true,
    },
    {
        key: 'wp-replace-url',
        name: __('Replace URL & Text', 'nexter-extension'),
        popDesc: __('Easily find and replace URL or text on your website. Useful when moving your site from one domain to another or just moving from http:// to https:// or going from www. to a non www. URL.', 'nexter-extension'),
        formField: { key: 'wp-replace-url', label: __('URL/Text', 'nexter-extension') },
        doclink: 'https://nexterwp.com/docs/change-url-in-a-wordpress-website/'
    },
    {
        key: 'wp-duplicate-post',
        name: __('Duplicate Post', 'nexter-extension'),
        popDesc: __('This will add a duplicate button to the post, page, custom post types that you can use to duplicate the same.', 'nexter-extension'),
        formField: { key: 'wp-duplicate-post', label: __('Duplicate Post', 'nexter-extension') },
        doclink: 'https://nexterwp.com/docs/duplicate-post-pages-cpt-products-at-bulk-in-wordpress/'
    },
    {
        key: 'regenerate-thumbnails',
        name: __('Regenerate Thumbnails', 'nexter-extension'),
        popDesc: __('Easily regenerate various sizes of image thumbnails at once or individually. This can be useful if image thumbnails are not showing properly on your website.', 'nexter-extension'),
        formField: { key: 'regenerate-thumbnails', label: __('Enter API Key', 'nexter-extension') },
        doclink : 'https://nexterwp.com/docs/regenerate-thumbnails-in-wordpress/'
    },
    {
        key: 'media-replacement',
        name: __('Replace Media', 'nexter-extension'),
        popDesc: __('Replace any existing media file without changing its URL, ID, or file name—perfect for updating images or documents without breaking links.', 'nexter-extension'),
        doclink : 'https://nexterwp.com/docs/replace-media-files-in-wordpress/',
        isPro : true,
        popshow : false,
        showSetting : false,
    },
    {
        key: 'content-post-order',
        name: __('Content Post Order', 'nexter-extension'),
        popDesc: __('Enable a custom order for your posts, pages, or media—perfect for manual sorting or organizing content just the way you want it.', 'nexter-extension'),
        formField: { key: 'content-post-order', label: __('Content Post Order', 'nexter-extension') },
        doclink : 'https://nexterwp.com/docs/reorder-posts-in-wordpress/',
    },
    {
        key: 'taxonomy-order',
        name: __('Taxonomy (Term) Order', 'nexter-extension'),
        popDesc: __('Easily order taxonomy terms (categories, tags or custom taxonomies) to control their display order in both wp-admin and the frontend.', 'nexter-extension'),
        doclink : 'https://nexterwp.com/docs/order-taxonomy-terms-in-wordpress/',
        formField: { key: 'taxonomy-order', label: __('Taxonomy (Term) Order', 'nexter-extension') },
        isPro : true,
        popshow : true,
        showSetting : false,
        isNew : true,
    },
    {
        key: 'disable-gutenberg',
        name: __('Disable Gutenberg', 'nexter-extension'),
        popDesc: __('Turn off the Gutenberg block editor for posts, pages, or both, perfect for those who prefer Classic Editor or use a page builder.', 'nexter-extension'),
        formField: { key: 'disable-gutenberg', label: __('Disable Gutenberg', 'nexter-extension') },
        doclink : 'https://nexterwp.com/docs/disable-gutenberg/',
    },
    {
        key: 'local-user-avatar',
        name: __('Custom User Avatar', 'nexter-extension'),
        popDesc: __('Allow users to set their profile picture by choosing any image from the Media Library—no need for a Gravatar account.', 'nexter-extension'),
        doclink : 'https://nexterwp.com/docs/add-custom-user-avatar-in-wordpress/',
        showSetting : false,
        isPro : true,
    },
    {
        key: 'public-preview-drafts',
        name: __('Public Preview for Drafts', 'nexter-extension'),
        popDesc: __('Enable a temporary public link for your draft content. Let others view unpublished posts/pages before they\'re live. Great for collecting feedback or client approval.', 'nexter-extension'),
        doclink : 'https://nexterwp.com/docs/enable-public-preview-for-unpublished-wordpress-posts/',
        formField: { key: 'public-preview-drafts', label: __('Public Preview for Drafts', 'nexter-extension') },
        isPro : true,
        popshow : true,
        showSetting : false,
    },
    {
        key: 'redirect-404-page',
        name: __('Redirect 404', 'nexter-extension'),
        popDesc: nxtext_ajax_object.pro ? __('When someone visits a broken 404 page or missing link on your site, this setting will send 301 redirect them to the page you choose.','nexter-extension') : __('301 (permanent) redirect to the homepage for all 404 (not found) pages.', 'nexter-extension'),
        doclink : 'https://nexterwp.com/docs/redirect-404-error-page-in-wordpress/',
        formField: { key: 'redirect-404-page', label: __('Redirect 404', 'nexter-extension') },
        isFreemium : true,
        popshow : true,
        showSetting : false,
    },
    {
        key: 'rollback-manager',
        name: __('Rollback Manager', 'nexter-extension'),
        popDesc: __('Easily switch back to restore a plugin or theme to its earlier version in just one click if something breaks after an update.', 'nexter-extension'),
        doclink : 'https://nexterwp.com/docs/rollback-theme-plugin-in-wordpress/',
        formField: { key: 'rollback-manager', label: __('Rollback Manager', 'nexter-extension') },
        showSetting : false
    },
    {
        key: 'view-admin-role',
        name: __('Admin Role Switcher', 'nexter-extension'),
        popDesc: __('View admin pages and the site as a non-administrator user to test and manage user role experiences.', 'nexter-extension'),
        doclink : 'https://nexterwp.com/docs/view-admin-pages-site-as-non-administrator-in-wordpress/',
        formField: { key: 'view-admin-role', label: __('Admin Role Switcher', 'nexter-extension') },
        isNew : true,
    },
    {
        key: 'wp-debug-mode',
        name: __('WP Debug Mode', 'nexter-extension'),
        popDesc: __('Enable Debug Mode to get detailed error logs and developer warnings, making it easier to troubleshoot and fix issues.', 'nexter-extension'),
        doclink : 'https://nexterwp.com/docs/enable-debug-mode-in-wordpress/',
        formField: { key: 'wp-debug-mode', label: __('WP Debug Mode', 'nexter-extension') },
        showSetting : false,
        isNew : true,
    },
];

var regen_thumbneils = nxtext_ajax_object?.dashData?.intermediateImgSize;
var disable_image_size = nxtext_ajax_object?.dashData?.nxtDisableImg || [];
var get_post_list = nxtext_ajax_object?.dashData?.post_list || [];
var get_taxonomy_list = nxtext_ajax_object?.dashData?.taxonomy_list || [];

var duplicate_post_status = {
    "same": __('Same as Original', 'nexter-extension'),
    "draft": __('Draft', 'nexter-extension'),
    "publish": __('Published', 'nexter-extension'),
    "pending": __('Pending', 'nexter-extension'),
    "private": __('Private', 'nexter-extension')
};

var variation_list = {
    "100": __('Thin 100', 'nexter-extension'),
    "200": __('Extra Light 200', 'nexter-extension'),
    "300": __('Light 300', 'nexter-extension'),
    "400": __('Regular 400', 'nexter-extension'),
    "500": __('Medium 500', 'nexter-extension'),
    "600": __('Semi-Bold 600', 'nexter-extension'),
    "700": __('Bold 700', 'nexter-extension'),
    "800": __('Extra-Bold 800', 'nexter-extension'),
    "900": __('Bolder 900', 'nexter-extension'),
    "100i": __('Thin 100 Italic', 'nexter-extension'),
    "200i": __('Extra Light 200 Italic', 'nexter-extension'),
    "300i": __('Light 300 Italic', 'nexter-extension'),
    "400i": __('Regular 400 Italic', 'nexter-extension'),
    "500i": __('Medium 500 Italic', 'nexter-extension'),
    "600i": __('Semi-Bold 600 Italic', 'nexter-extension'),
    "700i": __('Bold 700 Italic', 'nexter-extension'),
    "800i": __('Extra-Bold 800 Italic', 'nexter-extension'),
    "900i": __('Bolder 900 Italic', 'nexter-extension')
};

var variable_list = {
    'regular': __('Regular', 'nexter-extension'),
    'italic': __('Italic', 'nexter-extension')
};

const Settings = () => {
    const [enabledSettings, setEnabledSettings] = useState(() => {
        const extraSettings = nxtext_ajax_object?.dashData?.nxtExtra || {};
    
        // Initialize the settings object
        const defaultSettings = {
            'adobe-font': { 
                switch: (extraSettings['adobe-font'] && extraSettings['adobe-font'].switch) ? extraSettings['adobe-font'].switch : false,
                values: {

                }
            },
            'wp-duplicate-post': { 
                switch: (extraSettings['wp-duplicate-post'] && extraSettings['wp-duplicate-post'].switch) ? extraSettings['wp-duplicate-post'].switch : false,
                values: {
                    'nxt-duppost-access': 'all_users',
                    'nxt-duppost-author': 'current_author',
                    'nxt-duppost-date': 'original_date',
                    'nxt-duplicate-postfix': 'Copy',
                    'nxt-duplicate-slug': 'copy',
                    'nxt-duppost-status': 'same'
                }
            },
            'custom-upload-font' : {
                switch: (extraSettings['custom-upload-font'] && extraSettings['custom-upload-font'].switch) ? extraSettings['custom-upload-font'].switch : false,
                values: []
            },
            'wp-replace-url' : {
                switch: (extraSettings['wp-replace-url'] && extraSettings['wp-replace-url'].switch) ? extraSettings['wp-replace-url'].switch : false,
            },
            'regenerate-thumbnails' : {
                switch: (extraSettings['regenerate-thumbnails'] && extraSettings['regenerate-thumbnails'].switch) ? extraSettings['regenerate-thumbnails'].switch : false,
            },
            'media-replacement' : {
                switch: (extraSettings['media-replacement'] && extraSettings['media-replacement'].switch) ? extraSettings['media-replacement'].switch : false,
            },
            'content-post-order' : {
                switch: (extraSettings['content-post-order'] && extraSettings['content-post-order'].switch) ? extraSettings['content-post-order'].switch : false,
                values: []
            },
            'disable-gutenberg' : {
                switch: (extraSettings['disable-gutenberg'] && extraSettings['disable-gutenberg'].switch) ? extraSettings['disable-gutenberg'].switch : false,
                values: {
                    'posts' : [],
                    'frontend_style' : false
                }
            },
            'local-user-avatar' : {
                switch: (extraSettings['local-user-avatar'] && extraSettings['local-user-avatar'].switch) ? extraSettings['local-user-avatar'].switch : false,
            },
            'rollback-manager' : {
                switch: (extraSettings['rollback-manager'] && extraSettings['rollback-manager'].switch) ? extraSettings['rollback-manager'].switch : false,
            },
            'view-admin-role' : {
                switch: (extraSettings['view-admin-role'] && extraSettings['view-admin-role'].switch) ? extraSettings['view-admin-role'].switch : false,
            },
            'public-preview-drafts' : {
                switch: (extraSettings['public-preview-drafts'] && extraSettings['public-preview-drafts'].switch) ? extraSettings['public-preview-drafts'].switch : false,
                values: {
                    posts : [],
                    days : 3
                }
            },
            'redirect-404-page' : {
                switch: (extraSettings['redirect-404-page'] && extraSettings['redirect-404-page'].switch) ? extraSettings['redirect-404-page'].switch : false,
                values: ''
            },
            'wp-debug-mode' : {
                switch: (extraSettings['wp-debug-mode'] && extraSettings['wp-debug-mode'].switch) ? extraSettings['wp-debug-mode'].switch : false
            },
            'taxonomy-order' :{
                switch: (extraSettings['taxonomy-order'] && extraSettings['taxonomy-order'].switch) ? extraSettings['taxonomy-order'].switch : false,
                values: {
                    taxonomy : [],
                }
            },
            'smtp-email' : {
                switch: (extraSettings['smtp-email'] && extraSettings['smtp-email'].switch) ? extraSettings['smtp-email'].switch : false,
                values: {
                    'type' : 'gmail',
                    'gclient_id' : '',
                    'gsecret_key' : '',
                    'custom' : {
                        host: '',
                        port: '',
                        encryption: 'none',
                        autoTLS: true,
                        auth: true,
                        username: '',
                        password: '',
                        from_email: '',
                        from_name : ''
                    }
                }
            },
        };
    
        // Check if keys are present and merge with defaults
        if (!extraSettings['adobe-font'] || !extraSettings['adobe-font']['values']) {
            extraSettings['adobe-font'] = defaultSettings['adobe-font'];
        }
        if (!extraSettings['wp-duplicate-post'] || !extraSettings['wp-duplicate-post']['values']) {
            extraSettings['wp-duplicate-post'] = defaultSettings['wp-duplicate-post'];
        }
        if (!extraSettings['custom-upload-font'] || !extraSettings['custom-upload-font']['values']) {
            extraSettings['custom-upload-font'] = defaultSettings['custom-upload-font'];
        }
        if (!extraSettings['wp-replace-url']) {
            extraSettings['wp-replace-url'] = defaultSettings['wp-replace-url'];
        }
        if (!extraSettings['regenerate-thumbnails']) {
            extraSettings['regenerate-thumbnails'] = defaultSettings['regenerate-thumbnails'];
        }
        if (!extraSettings['media-replacement']) {
            extraSettings['media-replacement'] = defaultSettings['media-replacement'];
        }
        if (!extraSettings['content-post-order']) {
            extraSettings['content-post-order'] = defaultSettings['content-post-order'];
        }
        if (!extraSettings['disable-gutenberg']) {
            extraSettings['disable-gutenberg'] = defaultSettings['disable-gutenberg'];
        }
        if (!extraSettings['local-user-avatar']) {
            extraSettings['local-user-avatar'] = defaultSettings['local-user-avatar'];
        }
        if (!extraSettings['rollback-manager']) {
            extraSettings['rollback-manager'] = defaultSettings['rollback-manager'];
        }
        if (!extraSettings['view-admin-role']) {
            extraSettings['view-admin-role'] = defaultSettings['view-admin-role'];
        }
        if (!extraSettings['public-preview-drafts']) {
            extraSettings['public-preview-drafts'] = defaultSettings['public-preview-drafts'];
        }
        if (!extraSettings['redirect-404-page']) {
            extraSettings['redirect-404-page'] = defaultSettings['redirect-404-page'];
        }
        if (!extraSettings['taxonomy-order']) {
            extraSettings['taxonomy-order'] = defaultSettings['taxonomy-order'];
        }
        if (!extraSettings['smtp-email'] || !extraSettings['smtp-email']['values']) {
            extraSettings['smtp-email'] = defaultSettings['smtp-email'];
        }
        if (!extraSettings['wp-debug-mode']) {
            extraSettings['wp-debug-mode'] = defaultSettings['wp-debug-mode'];
        }
        return {
            ...extraSettings,
        };
    });

    const [message, setMessage] = useState('');
    const [msgType, setMsgType] = useState('');
    const [isError, setIsError] = useState(false);
    const [isGProcess, setGProcess] = useState('');
    const [isCProcess, setCProcess] = useState('');
    const [sendMailProcess, setSendMailProcess] = useState('');
    const [sendMailTo, setSendMailTo] = useState('');
    const redirectInputRef = useRef(null);
    const [copied, setCopied] = useState(false);

    const popupRef = useRef(null);
    const intervalRef = useRef(null);
    
    const [wpTables, setWpTables] = useState({});
    const [isLoadingTables, setIsLoadingTables] = useState(false);

    const [replaceFind, setReplaceFind] = useState( false );
    const [replaceorelse, setReplaceorElse] = useState('');
    const [processReplace, setProcessReplace] = useState( false );
    const [replaceMsg, setReplaceMsg] = useState( '' );

    const defaultReplaceOpt = {
        'wp-replace-url': {
            'from': '',
            'to': '',
            'case': 'no',
            'guid': 'no',
            'tables': [],
            'limit': 2000
        }
    };

    const [replaceOpt, setReplaceOpt] = useState(defaultReplaceOpt);
    
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isPopupProVisible, setIsPopupProVisible] = useState(false);
    const [isPopupExtensionInstall, setIsPopupExtensionInstall] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupInputValue, setPopupInputValue] = useState({});
    const [simpleFont, setSimpleFont] = useState(false);
    const [simpleFontEdit, setSimpleFontEdit] = useState(false);
    const [simpleList, setSimpleList] = useState({});
    const [simpleDefList, setSimpleDefList] = useState({});
    const [editFontSId, setEditFontSId] = useState('');
    const [editFontVId, setEditFontVId] = useState('');
    const [variableFont, setVariableFont] = useState(false);
    const [variableFontEdit, setVariableFontEdit] = useState(false);
    const [selectedPostStatus, setSelectedPostStatus] = useState(enabledSettings['wp-duplicate-post']?.values?.['nxt-duppost-status'] || 'same');

    const [defaultSimple, setDefaultSimple] = useState('');
    const [simpleUniId, setSimpleUniId] = useState('');

    const [defaultVariable, setDefaultVariable] = useState('');
    const [VariableUniId, setVariableUniId] = useState('');

    const [isContentDisabled, setIsContentDisabled] = useState(true);
   
    const generateUniqueId = () => {
        return Math.random().toString(36).substr(2, 6);
    };

    const openFontUploader = (key, fontType, type) => {
        const fontUploader = window.wp.media({
            title: __('Select or Upload Font File', 'nexter-extension'),
            button: {
                text: __('Use this file', 'nexter-extension'),
            },
            library: {
                type: ['font/woff2', 'font/ttf', 'font/otf', 'font/woff', 'application/x-font-ttf'], // Restrict to .woff2 and .ttf
            },
            multiple: false,
        });

        fontUploader.on('select', () => {
            const attachment = fontUploader.state().get('selection').first().toJSON();
            if( fontType == 'simple'){
                if(type == 'edit'){
                    const updateSimpleList = { ...simpleList }
                    updateSimpleList[key].filename = attachment.filename
                    updateSimpleList[key].id = attachment.id
                    setSimpleList(updateSimpleList)
                }else{
                    const updateSimpleList = { ...simpleDefList }
                    updateSimpleList[key].filename = attachment.filename
                    updateSimpleList[key].id = attachment.id
                    setSimpleDefList(updateSimpleList)
                }
            }else{
                if(type == 'edit'){
                    setVariableList(editFontVId, key, attachment)
                }else{
                    const updatedSettings = { ...defaultVariable };
                    defaultVariable[VariableUniId].variablefont.lists[key].filename = attachment.filename;
                    defaultVariable[VariableUniId].variablefont.lists[key].id = attachment.id;
                    setDefaultVariable(updatedSettings);
                }
            }
        });

        wp.media.frame.on('upload:complete', function() {
            fontUploader.state().get('library').observeChanges();
        });
        fontUploader.on('open',() => {
            const library = fontUploader.state().get('library');
            library.props.set('type', ['font/woff2', 'font/ttf','font/otf', 'font/woff','application/x-font-ttf']);
            library.props.set('orderby', 'date');
            library.props.set('order', 'DESC');
            library.more().then(() => {
                library.observeChanges();
            });
        });
        fontUploader.open();
    };
    
    const handleFontUpload = () => {
        let total = (enabledSettings['custom-upload-font']?.values?.length ?? 0) || 0;
        if(proAct || (!proAct && total < 5)){
            setSimpleFont(true);
            if(!defaultSimple && !simpleUniId){
                const uniId = generateUniqueId();
                setSimpleUniId(uniId)
                const defaultSimF = { 
                    [uniId] : { 
                        "simplefont": {
                            "font_name": "Simple Font",
                            "lists": {
                                [generateUniqueId()]: {
                                    "id": '',
                                    "filename": "",
                                    "variation": "100"
                                },
                            }
                        },
                        "variablefont": ""
                    }
                };
                setDefaultSimple(defaultSimF);
                let list = defaultSimF[uniId].simplefont?.lists;
                setSimpleDefList(list)
            }
            setIsContentDisabled(false);
        }else{
            alert(__('Upgrade to Pro for more than 5 Custom Fonts!', 'nexter-extension'));
        }

    };
    const handleSFontEdit = (id) => {
        let getData = getFontData(id);
        let list = getData?.simplefont?.lists
        setSimpleList(list)
        setSimpleFontEdit(true);
        setEditFontSId(id);
        setIsContentDisabled(false);
    };

    const handleVFontEdit = (id) => {
        setVariableFontEdit(true);
        setEditFontVId(id);
        setIsContentDisabled(false);
    };

    const handleFontDelete = (e, id) =>{

        let confirma = '';

        confirma = confirm(__('Are you sure you want to remove this font? This action cannot be undone.', 'nexter-extension'));

        if(confirma){
            const updatedSettings = { ...enabledSettings };    
            updatedSettings['custom-upload-font'].values = updatedSettings['custom-upload-font'].values.filter(item => !item.hasOwnProperty(id));    
            setEnabledSettings(updatedSettings);
            handlePopupSave(e);
        }
    }

    const handleVarFontUpload = () => {
        let total = (enabledSettings['custom-upload-font']?.values?.length ?? 0) || 0;
        if(proAct || (!proAct && total < 5)){
            setVariableFont(true);
            if(!defaultVariable && !VariableUniId){
                const uniId = generateUniqueId();
                setVariableUniId(uniId)
                const defaultVarF = { 
                    [uniId] : { 
                        "simplefont": "",
                        "variablefont": {
                            "font_name": "Variable Font",
                            "lists": {
                                "regular": {
                                    "id": "",
                                    "filename": ""
                                },
                                "italic": {
                                    "id": "",
                                    "filename": ""
                                }
                            }
                        },
                    }
                };

                setDefaultVariable(defaultVarF);
            }
            setIsContentDisabled(false);
        }else{
            alert(__('Upgrade to Pro for more than 5 Custom Fonts!', 'nexter-extension'));
        }
    };

    const handleBack = () => {
        setSimpleFont(false);
        setSimpleFontEdit(false);
        setEditFontSId('');
        setVariableFont(false);
        setVariableFontEdit(false);
        setIsContentDisabled(true);
    };
    const handleCheckboxChange = (e, key, opt) => {
        const updateSwitch = { ...enabledSettings }
        updateSwitch[key]['switch'] = e.target.checked
        setEnabledSettings(updateSwitch)
        extraOptionsSave(e, key, opt)
    };

    const adobeFontGet = () => {
        let settings = enabledSettings['adobe-font'].values;

        if (!settings || !settings.fonts || settings.fonts.length === 0) {
            return null;
        }
        const renderFontVariant = (variations) => {
            if (!variations || variations.length === 0) return '';
        
            return variations.map((variation) => {
              let formattedVariation = '';
              if (variation[0] === 'n') {
                formattedVariation = parseInt(variation.replace('n', '')) * 100;
                if (formattedVariation === 400) {
                  formattedVariation = 'Regular';
                }
              } else {
                formattedVariation = parseInt(variation.replace('i', '')) * 100 + ' italic';
              }
              return formattedVariation;
            }).join(', ');
        };
        const adobeFontsList = settings.fonts.map((val, key) => {            
            if (val && val.name) {
              const fontVariant = renderFontVariant(val.variations);
              return (
                <li key={key}>
                  <div className="adobe-font-name">
                    <span>
                      {/* Replace this with an SVG component or inline SVG */}
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23 1.02661H1V22.9733H23V1.02661Z" fill="#142500"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M0 24H24V0H0V24ZM1 1.02667H23V22.9733H1V1.02667Z" fill="#86EB00"/>
                        <path d="M7.16599 7.16015H4.39265C4.31265 7.16015 4.27932 7.12682 4.29265 7.02682L4.49265 5.60682C4.50599 5.52015 4.53932 5.48682 4.62599 5.48682H11.5527C11.6527 5.48682 11.686 5.52015 11.6993 5.62015L11.8327 7.02682C11.846 7.12682 11.7993 7.16015 11.7127 7.16015H8.95932V16.6335C8.95932 16.7201 8.92599 16.7668 8.83265 16.7668H7.29265C7.19932 16.7668 7.16599 16.7335 7.16599 16.6335V7.16015Z" fill="#86EB00"/>
                        <path d="M14.7187 12.0534L17.2387 8.54675C17.3054 8.46675 17.3254 8.43342 17.4054 8.43342H19.0854C19.1854 8.43342 19.2187 8.50008 19.152 8.58008C18.7587 9.10675 16.9454 11.4067 16.352 12.1534C16.3422 12.1682 16.337 12.1856 16.337 12.2034C16.337 12.2212 16.3422 12.2386 16.352 12.2534L19.5454 16.6334C19.5787 16.7001 19.5654 16.7667 19.4654 16.7667H17.5187C17.4837 16.7718 17.448 16.7646 17.4176 16.7464C17.3872 16.7282 17.3641 16.7 17.352 16.6667C16.812 15.9267 15.412 13.9267 14.7187 12.8934V16.6534C14.7187 16.7334 14.6987 16.7667 14.5987 16.7667H13.052C12.932 16.7667 12.9187 16.7334 12.9187 16.6334V5.58675C12.9187 5.54008 12.932 5.48675 13.032 5.48675H14.5987C14.6149 5.48495 14.6313 5.48682 14.6467 5.49221C14.662 5.4976 14.676 5.50639 14.6875 5.51791C14.6991 5.52944 14.7078 5.5434 14.7132 5.55878C14.7186 5.57416 14.7205 5.59055 14.7187 5.60675V12.0534Z" fill="#86EB00"/>
                      </svg>
                    </span>
                    {val.name}
                  </div>
                  <div className="adobe-font-variant">{__('Variation: ', 'nexter-extension')}{fontVariant}</div>
                </li>
              );
            }
            return null;
        });        
        return <ul className="nxt-adobe-font-list">{adobeFontsList}</ul>;
    }
    
    useEffect(() => {

        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                setIsPopupVisible(false);
                setPopupData(null);
                setPopupInputValue({});
            }
        };

        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, []);
    const handleKeyDown = (event) => {
        if((event.metaKey && event.key === 'a') || (event.ctrlKey && event.key === 'a')) {
            event.preventDefault();
            Object.entries(wpTables).map(([id, name]) => {
                const updatedSettings = { ...replaceOpt };
                const index = updatedSettings['wp-replace-url']['tables'].indexOf(id);
                if (index === -1) {
                    updatedSettings['wp-replace-url']['tables'].push(id);
                }
                setReplaceOpt(updatedSettings);
            })
        }
    };

    const fetchWpTables = async () => {
        if (Object.keys(wpTables).length > 0) {
            return;
        }
        
        setIsLoadingTables(true);
        
        try {
            const formData = new FormData();
            formData.append('action', 'nexter_get_replace_url_tables');
            formData.append('nexter_nonce', nexter_admin_config.ajax_nonce);
            
            const response = await fetch(nxtext_ajax_object?.ajax_url, {
                method: 'POST',
                body: formData,
            });
            
            const result = await response.json();
            
            if (result.success && result.data.tables) {
                setWpTables(result.data.tables);
            }
        } catch (error) {
            //console.error('Error fetching tables:', error);
        } finally {
            setIsLoadingTables(false);
        }
    };

    const handleOpenPopup = (data) => {
        setReplaceorElse(data.key)
        setPopupData(data);
        const initialPopupInputValue = {};
        Object.keys(data.formField).forEach(key => {
            initialPopupInputValue[key] = enabledSettings[key] || '';
        });
        setPopupInputValue(initialPopupInputValue);
        setIsPopupVisible(true);
        // Fetch tables data when Replace URL popup opens
        if (data.key === 'wp-replace-url') {
            fetchWpTables();
        }
    };

    const handleClosePopup = () => {
        setSimpleFont(false);
        setVariableFont(false)
        setSimpleFontEdit(false);
        setIsContentDisabled(true);
        setIsPopupVisible(false);
        setPopupData(null);
        setPopupInputValue({});
    };

    const replaceButtonClick = async (e) => {
        
        let popWrap = e.target.closest('.nxtext_settings_popup');
        let cardWrap = popWrap.querySelector('.nxtext_field_card_cover');
    
        let getID = cardWrap.getAttribute('id'); 
        if (popupData) {
            setEnabledSettings((prevState) => ({
                ...prevState,
                ...popupInputValue,
            }));

            let replaceData = replaceOpt[getID]
            setReplaceMsg('');
            setProcessReplace(true);
            if (!replaceData.from || !replaceData.from) {
                setReplaceMsg('Please Enter Old URL/Text.');
                setProcessReplace(false);
                return;
            }
            if (!replaceData.to || !replaceData.to) {
                setReplaceMsg('Please Enter New URL/Text.');
                setProcessReplace(false);
                return;
            }
            if (!replaceData.tables || !replaceData.tables.length) {
                setReplaceMsg('Select any table before replace');
                setProcessReplace(false);
                return;
            }

            const formData = new FormData();
            formData.append('extension_type', getID);
            formData.append('action', 'nxt_replace_url');
            Object.entries(replaceOpt[getID]).forEach(([key, value]) => {
                if(key == 'tables'){
                    formData.append(key, JSON.stringify(value));
                }else{
                    formData.append(key, value);
                }
            });
            
            formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
                    
            // handleClosePopup();
            await nxtReplaceBtnClick(e, formData, setReplaceFind, 'replace')
            setProcessReplace(false);
        }
    };

    const handlePopupSave = async (e) => {
        if(simpleFont && validateDefaultSimple(defaultSimple, false)){
            const updatedSettings = { ...enabledSettings };    
            updatedSettings['custom-upload-font'].values.push(defaultSimple);    
            setEnabledSettings(updatedSettings);
        }else if(variableFont && validateDefaultVariable(defaultVariable, false)){
            const updatedSettings = { ...enabledSettings };    
            updatedSettings['custom-upload-font'].values.push(defaultVariable);    
            setEnabledSettings(updatedSettings);
        }

        let popWrap = e.target.closest('.nxtext_settings_popup');
        let cardWrap = popWrap.querySelector('.nxtext_field_card_cover');
    
        let getID = cardWrap.getAttribute('id'); 
        if (popupData) {
            setEnabledSettings((prevState) => ({
                ...prevState,
                ...popupInputValue,
            }));

            const formData = new FormData();

            if(getID != 'wp-replace-url' && getID != 'adobe-font' && getID != 'regenerate-thumbnails'){
                formData.append('action', 'nexter_ext_save_data');
            }
            formData.append('extension_type', getID);
            if(getID == 'wp-duplicate-post'){
                formData.append('wpDupPostSet', JSON.stringify(enabledSettings[getID].values)); 
            }else if(getID == 'content-post-order'){
                formData.append('post_types', JSON.stringify(enabledSettings[getID].values)); 
            }else if(getID == 'disable-gutenberg'){
                formData.append('disable_gutenberg_posts', JSON.stringify(enabledSettings[getID].values)); 
            }else if(getID == 'public-preview-drafts'){
                formData.append('preview_drafts', JSON.stringify(enabledSettings[getID].values)); 
            }else if(getID == 'taxonomy-order'){
                formData.append('taxonomy_order', JSON.stringify(enabledSettings[getID].values)); 
            }else if(getID == 'redirect-404-page'){
                formData.append('redirect_404', enabledSettings[getID].values); 
            }else if(getID == 'wp-replace-url'){
                formData.append('action', 'nxt_replace_confirm_url');
                Object.entries(replaceOpt[getID]).forEach(([key, value]) => {
                    if(key == 'tables'){
                        formData.append(key, JSON.stringify(value));
                    }else{
                        formData.append(key, value);
                    }
                });
            }else if(getID == 'custom-upload-font'){
                formData.append('fonts', JSON.stringify(enabledSettings[getID].values));
            }else if(getID == 'adobe-font'){
                formData.append('action', 'nexter_ext_save_adobe_font_data');
                formData.append('project_id', enabledSettings[getID].values.project_id);
            }else if(getID == 'regenerate-thumbnails'){
                formData.append('action', 'nexter_regenerate_image_thumbnails');

                let joinedValues = Object.keys(regen_thumbneils).filter(item => !disable_image_size.includes(regen_thumbneils[item])).map(item => regen_thumbneils[item]).join(',');
                                
                formData.append('image_sizes_to_be_generated', joinedValues);
            }else if(getID == 'smtp-email'){
                formData.append('smtpEmail', JSON.stringify(enabledSettings[getID].values));
            }
            
            formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
                    
            if(getID != 'wp-replace-url' && getID != 'adobe-font' && getID != 'regenerate-thumbnails' && getID != 'custom-upload-font'){
                await nxtdash_save_data(e, formData)
                
                setTimeout(() => {
                    handleClosePopup();    
                }, 300);
            }else if(getID == 'wp-replace-url'){
                nxtReplaceBtnClick(e, formData, setReplaceFind, 'confirm');
                setReplaceOpt(defaultReplaceOpt)
                setReplaceFind(false)
            }else if(getID == 'adobe-font'){
                nxtAdobeFontGet(e, formData, enabledSettings, setEnabledSettings);            
            }else if(getID == 'regenerate-thumbnails'){
                let joinedValues = Object.keys(regen_thumbneils).filter(item => !disable_image_size.includes(regen_thumbneils[item])).map(item => regen_thumbneils[item]).join(',');
                nxtRegenerateThumb(e, formData,nxtext_ajax_object.ajax_nonce, joinedValues)
            }else if(getID == 'custom-upload-font'){
                if(simpleFont && validateDefaultSimple(defaultSimple, true)){
                    nxtdash_save_simplefont(e, formData, setDefaultSimple, setSimpleUniId, setSimpleFont, setIsContentDisabled);                   
                }else if(variableFont && validateDefaultVariable(defaultVariable, true)){
                    nxtdash_save_variablefont(e, formData, setDefaultVariable, setVariableUniId, setVariableFont, setIsContentDisabled);
                }else if(!simpleFont && !variableFont){
                    nxtdash_save_data(e, formData, handleBack)
                }
            }
        }
    };

    const copyRedirectURL = () => {
        const input = redirectInputRef.current;
        if (input) {
        navigator.clipboard.writeText(input.value).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); 
        }).catch(err => {
            console.error('Copy failed:', err);
        });
        }
    };

    const smtpAuthCustom = (e) => {
        e.preventDefault();
        setMsgType('custom')
        let smtpData = enabledSettings['smtp-email']
        if (!smtpData.switch || !smtpData.values || !smtpData.values.custom) {
            setMessage('Please Enter Value.');
            setIsError(true);
            return;
        }
        let customData = smtpData.values.custom;

        if(customData && !customData?.host){
            setMessage('Please Enter SMTP Host.');
            setIsError(true);
            return;
        }
        if(customData && !customData?.port){
            setMessage('Please Enter SMTP Port Value.');
            setIsError(true);
            return;
        }
        if(customData && !customData?.encryption){
            setMessage('Please Choose SMTP Encryption.');
            setIsError(true);
            return;
        }
        if(customData && !customData?.username){
            setMessage('Please Enter Username.');
            setIsError(true);
            return;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        if (customData && customData?.from_email && !emailPattern.test(customData.from_email)) {
            setMessage('Please Enter a Valid From Email Address.');
            setIsError(true);
            return;
        }

        if(customData && !customData?.password){
            setMessage('Please Enter Password.');
            setIsError(true);
            return;
        }

        const formData = new FormData();
        formData.append('action', 'nxt_smtp_custom_auth');
        formData.append('smtp_nonce', nxtext_ajax_object?.ajax_nonce); // nonce field
        
        formData.append('smtp_type', smtpData?.values?.type || '');
        formData.append('smtp_custom', JSON.stringify(smtpData?.values?.custom || {}));
        
        setMessage('');
        setIsError(false);
        setCProcess('Connecting...')
        fetch(nxtext_ajax_object?.ajax_url, {
            method: 'POST',
            body: formData,
        })
        .then(res => res.json())
        .then(response => {
            if (response.success) {
                if(response.data.message){
                    setMessage(response.data.message);
                }
                setIsError(false);
                setCProcess('✓ Authorized')
                setMsgType('custom')
                const updatedSettings = { ...enabledSettings };
                if(response.data.connect){
                    updatedSettings['smtp-email'].values.custom.connect = response.data.connect;
                }
                setEnabledSettings(updatedSettings);
            }else{
                setMessage(response.data);
                setIsError(true);
                setCProcess('Connection failed')
                setTimeout(() => {
                    setCProcess('Retry Connect Now')
                }, 2500);
                setMsgType('custom')
            }
        })
        .catch(() => {
            setMessage('An error occurred during SMTP.');
            setIsError(true);
            setCProcess('Connect Now')
            setMsgType('custom')
        });
    }
    const smtpAuthGmail = (e) => {
        e.preventDefault();
        setMsgType('gmail')
        let smtpData = enabledSettings['smtp-email']
        if (!smtpData.switch || !smtpData.values) {
            setMessage('Please Enter Fill Value.');
            setIsError(true);
            return;
        }
        if(smtpData.values && smtpData?.values?.type!='gmail'){
            setMessage('Please Select Type Gmail SMTP.');
            setIsError(true);
            return;
        }
        if(smtpData.values && !smtpData?.values?.gclient_id){
            setMessage('Please Enter Client ID.');
            setIsError(true);
            return;
        }
        if(smtpData.values && !smtpData?.values?.gsecret_key){
            setMessage('Please Enter Client Secret.');
            setIsError(true);
            return;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        if (smtpData.values && smtpData.values?.email && !emailPattern.test(smtpData.values?.email)) {
            setMessage('Please Enter a Valid From Email Address.');
            setIsError(true);
            return;
        }

        const formData = new FormData();
        formData.append('action', 'nxt_smtp_gmail_auth');
        formData.append('smtp_nonce', nxtext_ajax_object?.ajax_nonce); // nonce field
        
        formData.append('smtp_type', smtpData?.values?.type || '');
        formData.append('smtp_gclient', smtpData?.values?.gclient_id || '');
        formData.append('smtp_gsecret', smtpData?.values?.gsecret_key || '');
        formData.append('smtp_from_name', smtpData?.values?.name || '');
        formData.append('smtp_from_email', smtpData?.values?.email || '');
        
        setMessage('');
        setIsError(false);
        setGProcess('Authorizing...')
        fetch(nxtext_ajax_object?.ajax_url, {
            method: 'POST',
            body: formData,
        })
        .then(res => res.json())
        .then(response => {
            if (response.success) {
                if(response.data.oauth_url){
                    const oauthUrl = response.data.oauth_url;
                    const width = 600;
                    const height = 600;
                    const left = window.screen.width / 2 - width / 2;
                    const top = window.screen.height / 2 - height / 2;

                    popupRef.current = window.open(
                        oauthUrl,
                        'Gmail Authorization',
                        `width=${width},height=${height},top=${top},left=${left}`
                    );

                    intervalRef.current = setInterval(() => {
                        if (!popupRef.current || popupRef.current.closed) {
                            clearInterval(intervalRef.current);
                            checkGmailAuthStatus();
                        }
                    }, 100);
                    setMsgType('gmail')
                }else{
                    setMessage(response.data);
                    setIsError(false);
                    setGProcess('Authorization failed')
                    setTimeout(() => {
                        setGProcess('Retry Authorize Gmail')
                        setMessage('')
                    }, 2000);
                    setMsgType('gmail')
                }
            } else {
                setMessage(response.data);
                setIsError(true);
                setGProcess('Authorization failed')
                setTimeout(() => {
                    setGProcess('Retry Authorize Gmail')
                }, 2500);
                setMsgType('gmail')
            }
        })
        .catch(() => {
            setMessage('An error occurred during SMTP.');
            setIsError(true);
            setGProcess('Authorize with Gmail')
            setMsgType('gmail')
        });
    }

    const checkGmailAuthStatus = () => {
        setMsgType('gmail')
        fetch(window?.nxtext_ajax_object?.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: 'nxt_smtp_gmail_auth_status',
                nonce: nxtext_ajax_object?.gmail_auth_check_nonce,
            }),
        })
        .then((res) => res.json())
        .then((response) => {
            if (response.success) {
                if(response.data.message){
                    setMessage(response.data.message);
                }
                setIsError(false);
                setGProcess('✓ Authorized')
                const updatedSettings = { ...enabledSettings };
                if(response.data.access_token){
                    updatedSettings['smtp-email'].values.access_token = response.data.access_token;
                }
                if(response.data.email_id){
                    updatedSettings['smtp-email'].values.email = response.data.email_id;
                }
                setEnabledSettings(updatedSettings); 
            } else {
                setMessage(response.data);
                setIsError(true);
                setGProcess('Authorization failed')
                setTimeout(() => {
                    setGProcess('Retry Authorize Gmail')
                }, 2500);
            }
        })
        .catch(() => {
            setMessage('Authorization failed: AJAX request failed.');
            setIsError(true);
        });
    };


    //send Test Mail
    const smtpSendMail = (e, smtpType='') => {
        if(smtpType){
            setMsgType(smtpType)
        }
        if(!sendMailTo){
            setMessage('Please Enter Email ID to send the test mail.');
            setIsError(true);
        }
        setMessage('');
        setIsError(false);
        setSendMailProcess('loader');
        fetch(window?.nxtext_ajax_object?.ajax_url, {
            method: 'POST',
            body: new URLSearchParams({
                action: 'nxt_smtp_send_test_email',
                nonce: nxtext_ajax_object?.ajax_nonce,
                send_to : sendMailTo || '',
            }),
        })
        .then((res) => res.json())
        .then((response) => {
            if (response.success) {
                setMessage(response.data);
                setIsError(false);
                setSendMailProcess('success');
            } else {
                setMessage(response.data);
                setIsError(true);
                setSendMailProcess('failed');
            }
            setTimeout(() => {
                setSendMailProcess('');
            }, 2500);
        })
        .catch(() => {
            setMessage('Send Mail failed: AJAX request failed.');
            setSendMailProcess('');
            setIsError(true);
        });
    }

    const validateDefaultSimple = (defaultSimple, alertEnable = false) => {
        const uniId = Object.keys(defaultSimple)[0];
        const simpleFont = defaultSimple[uniId]?.simplefont;
    
        if (!simpleFont?.font_name || simpleFont?.font_name.trim() === "") {
            if(alertEnable){
                alert(__('Font name cannot be empty.', 'nexter-extension'));
            }
            return false;
        }
    
        for (const listId in simpleFont?.lists) {
            const listItem = simpleFont.lists[listId];
            if (!listItem.filename || listItem.filename.trim() === "") {
                if(alertEnable){
                    alert(__('Filename cannot be empty.', 'nexter-extension'));
                    
                }
                return false;
            }
        }
        return true;
    };

    const validateDefaultVariable = (defaultVariable, alertEnable = false) => {
        const uniId = Object.keys(defaultVariable)[0]; // Assuming only one key in defaultVariable
        const variableFont = defaultVariable[uniId]?.variablefont;
    
        if (!variableFont?.font_name || variableFont.font_name.trim() === "") {
            if(alertEnable){
                alert(__('Font name cannot be empty.', 'nexter-extension'));
            }
            return false;
        }
    
        if (!variableFont?.lists?.regular?.filename || variableFont.lists.regular.filename.trim() === "") {
            if(alertEnable){
                alert(__('Upload Regular font file.', 'nexter-extension'));
            }
            return false;
        }
    
        if (!variableFont?.lists?.italic?.filename || variableFont.lists.italic.filename.trim() === "") {
            if (alertEnable) {
                alert(__('Upload Italic font file.', 'nexter-extension'));
            }
            return false;
        }
    
        return true;
    };
    

    const Drop_down_toggle = (e) => {
        let main_object = e.target.closest(".nxtext_cstm_dropdown")
        let drop_down = main_object.querySelector(".nxtext_cstm_dropdown_content") ? main_object.querySelector(".nxtext_cstm_dropdown_content") : "";
        if (drop_down) {
            if (Object.values(drop_down.classList).includes("nxt_wp_show")) {
                drop_down.classList.remove("nxt_wp_show");
            } else {
                drop_down.classList.add("nxt_wp_show");
            }
        }
    }

    const changePostStatus = (e, id, name, field) => {
        setSelectedPostStatus(name);
        const updatedSettings = { ...enabledSettings };
        updatedSettings[field].values['nxt-duppost-status'] = id;
        setEnabledSettings(updatedSettings);        
    }

    const changeDupToggle = (val, key, field) => {
        const updatedSettings = { ...enabledSettings };
        updatedSettings[field].values[key] = val;
        setEnabledSettings(updatedSettings); 
    }

    const handleChange = (key, value, field) => {
        const updatedSettings = { ...enabledSettings };
        if (!updatedSettings[field].values.custom) {
            updatedSettings[field].values.custom = {};
        }
        updatedSettings[field].values.custom[key] = value;
        delete updatedSettings[field]?.values?.access_token;
        delete updatedSettings[field]?.values?.custom?.connect;
        setEnabledSettings(updatedSettings);
        setMessage('');
        setIsError(false);
    };

    const changeArrayToggle = (value, key = '', field) => {
        const updated = { ...enabledSettings };

        if (!updated[field]) {
            updated[field] = { values: key ? {} : [] };
        }

        if (!updated[field].values) {
            updated[field].values = {};
        }
        if (key) {
            if (!Array.isArray(updated[field].values?.[key])) {
                updated[field].values[key] = [];
            }

            const index = updated[field].values[key].indexOf(value);
            if (index > -1) {
                updated[field].values[key].splice(index, 1);
            } else {
                updated[field].values[key].push(value);
            }
        } else {
            // Handle direct array
            if (!Array.isArray(updated[field].values)) {
                updated[field].values = [];
            }

            const index = updated[field].values.indexOf(value);
            if (index > -1) {
                updated[field].values.splice(index, 1);
            } else {
                updated[field].values.push(value);
            }
        }
        setEnabledSettings(updated);
    };

    const simpleFontList = (font, id) => {
        const fontName = font.simplefont?.font_name;
        var font_variant = '', simple_font_data = font.simplefont;
        if(simple_font_data && simple_font_data.lists){
            for(const list in simple_font_data.lists){                
                font_variant += (simple_font_data.lists[list].variation) ? variation_list[simple_font_data.lists[list].variation]+', ' : '';                
            }
            font_variant = font_variant.trim().replace(/,\s*$/, '');
        }

        if(fontName){
            return (<div className='nxtext_adobe_scan_border'>
                <div className='nxtext_crd_heading'>
                    <div className='nxtext_secondary_heading'>{fontName}</div>
                    <div className='nxtext_paragrph'>{font_variant || 'No variants available'}</div>
                </div>
                <div className='nxtext_crd_icons'>
                    <span className='nxtext_verysm_ico_pair' onClick={()=> {handleSFontEdit(id)}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
                            <path stroke="#1717CC" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".917" d="M14.387 2.613a2.102 2.102 0 0 0-2.987.02L3.023 11.01 2 15l3.99-1.023 8.377-8.378a2.101 2.101 0 0 0 .02-2.986Z" />
                        </svg>
                    </span>
                    <span style={{ paddingTop: '3px' }}>|</span>
                    <span className='nxtext_verysm_ico_pair' onClick={(e)=>{ handleFontDelete(e, id) }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
                            <path stroke="#1A1A1A" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".917" d="M7 11.75V7.416m3 4.334V7.416m-8-3.25h13M12 15H5a.962.962 0 0 1-.707-.317A1.13 1.13 0 0 1 4 13.917v-9.75h9v9.75c0 .287-.105.563-.293.766A.963.963 0 0 1 12 15ZM10 2H7a.963.963 0 0 0-.707.317A1.13 1.13 0 0 0 6 3.083v1.084h5V3.083c0-.287-.106-.563-.293-.766A.963.963 0 0 0 10 2Z" />
                        </svg>
                    </span>
                </div>
            </div>)
        }
    }

    const simpleFontAddPopup = () => {
        return(
            <div className="nxtext_simple_font_main_cover">
                <div className='nxtext_field_with_lbl'>
                    <label className='nxtext_secondary_heading'>{__('Font Name', 'nexter-extension')}</label>
                    <input id="text_field_1" className="nxtext_text_field" value={defaultSimple[simpleUniId].simplefont.font_name} type="text" placeholder={__('Enter Font Name', 'nexter-extension')} onChange={(e)=> {
                        const updatedefaultSimple = { ...defaultSimple }
                        updatedefaultSimple[simpleUniId].simplefont.font_name = e.target.value
                        setDefaultSimple(updatedefaultSimple)
                    }}/>
                </div>
                <div className='nxtext_simpfont_text_cover'>
                    {simpleDefList && Object.keys(simpleDefList).map((key,index) => (
                        <>
                            <div className='nxtext_simpfontiner_stripver' key={index.toString()}>
                                <div className="nxtext_simple_font_inner_div">

                                    <div className="nxtext_simple_font_text_select">
                                        <div className="nxtext_file_input">
                                            <label htmlFor={simpleDefList[key].id || 'simple-font'+key} className="nxtext_file_input_label">{__('--Choose File--', 'nexter-extension')}</label>
                                            <input className="nxtext_file_input_field" id={simpleDefList[key].id || 'simple-font'+key} value={simpleDefList[key].filename} type="text" placeholder={__('Upload Your Font', 'nexter-extension')} onClick={()=>{openFontUploader(key, 'simple', 'add')}}
                                            onChange={(e) => {}} />
                                            <span className="nxtext_file_upload_btn">{ simpleDefList[key].filename || '' }</span>
                                        </div>
                                        <div className='nxtext_cstm_dropdown' onClick={(e) => { Drop_down_toggle(e) }}>
                                            <div className='nxtext_cstm_dropdown_header'>
                                                <label className='nxt_paragraph' htmlFor="nxt_rollVersion">{ variation_list[simpleDefList[key].variation]}</label>
                                                <img src={plugin_url + 'assets/svg/nxt_chevron_down.svg'} draggable={false} />
                                            </div>
                                            <div id="nxt_rollVersion" className='nxtext_cstm_dropdown_content'>
                                                {Object.entries(variation_list).map(([id, name]) => (
                                                    <div key={id} className='nxt-option'value={id} onClick={(ev) => {
                                                        const updateSimpleList = { ...simpleDefList }
                                                        updateSimpleList[key].variation = id
                                                        setSimpleDefList(updateSimpleList)
                                                    }}>{name}</div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="nxtext_simple_font_icon">
                                    <span onClick={()=>{ handleRemoveRow(simpleUniId, key, 'new')}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                                            <path stroke="#CCC" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.3" d="M6.385 11.23V6.923m3.23 4.307V6.923M1 3.693h14M11.77 14.46H4.23a1.077 1.077 0 0 1-1.077-1.077V3.692h9.692v9.692a1.076 1.076 0 0 1-1.076 1.077ZM9.615 1.538h-3.23a1.077 1.077 0 0 0-1.078 1.077v1.077h5.385V2.615a1.077 1.077 0 0 0-1.077-1.077Z" />
                                        </svg>
                                    </span>

                                </div>

                            </div>
                        </>
                    ))}
                </div>

                <button className="nxtext_primary_btn" onClick={()=>{handleAddRow(simpleUniId, 'new')}}>{__('Add Variant', 'nexter-extension')}</button>

            </div>
        )
    }

    const getFontData = (editFontSId) => {
        for (let i = 0; i < enabledSettings['custom-upload-font'].values.length; i++) {
          if (enabledSettings['custom-upload-font'].values[i].hasOwnProperty(editFontSId)) {
            return enabledSettings['custom-upload-font'].values[i][editFontSId];
          }
        }
        return null;
    };
    const setFontName = (editFontSId, value) => {
        for (let i = 0; i < enabledSettings['custom-upload-font'].values.length; i++) {
          if (enabledSettings['custom-upload-font'].values[i].hasOwnProperty(editFontSId)) {            
            const updatedSettings = { ...enabledSettings };
            enabledSettings['custom-upload-font'].values[i][editFontSId].simplefont.font_name = value
            setEnabledSettings(updatedSettings);
          }
        }
    };
    const setVFontName = (editFontVId, value) => {
        for (let i = 0; i < enabledSettings['custom-upload-font'].values.length; i++) {
          if (enabledSettings['custom-upload-font'].values[i].hasOwnProperty(editFontVId)) {            
            const updatedSettings = { ...enabledSettings };
            enabledSettings['custom-upload-font'].values[i][editFontVId].variablefont.font_name = value
            setEnabledSettings(updatedSettings);
          }
        }
    };
    
    const updateSimpleLists = (editFontSId, updatedList, type) => {
        if(type=='edit'){
            for (let i = 0; i < enabledSettings['custom-upload-font'].values.length; i++) {
              if (enabledSettings['custom-upload-font'].values[i].hasOwnProperty(editFontSId)) {            
                const updatedSettings = { ...enabledSettings };
                enabledSettings['custom-upload-font'].values[i][editFontSId].simplefont.lists = updatedList
                setEnabledSettings(updatedSettings);
              }
            }
        }else{      
            const updatedSettings = { ...defaultSimple };
            updatedSettings[editFontSId].simplefont.lists = updatedList
            setDefaultSimple(updatedSettings);
        }
    };
    const handleAddRow = (editFontSId, type) => {        
        const newId = generateUniqueId();
        const newRow = {
            id: '',
            filename: '',
            variation: '100'
        };

        if(type == 'edit'){
            setSimpleList((prevList) => {
                const updatedList = {
                  ...prevList,
                  [newId]: newRow
                };
            
                updateSimpleLists(editFontSId, updatedList, type);
            
                return updatedList;
            });
        }else{
            setSimpleDefList((prevList) => {
                const updatedList = {
                    ...prevList,
                    [newId]: newRow
                };
            
                updateSimpleLists(editFontSId, updatedList, type);
            
                return updatedList;
            });
        }
    };

    const handleRemoveRow = (editFontSId, key, type) => {
        if(type == 'edit'){
            setSimpleList((prevList) => {
              const updatedList = Object.fromEntries(
                Object.entries(prevList).filter(([id]) => id !== key)
              );
          
              // Pass the updated list to removeSimpleList after state update
              updateSimpleLists(editFontSId, updatedList, type);
          
              return updatedList;
            });
        }else{
            setSimpleDefList((prevList) => {
                const updatedList = Object.fromEntries(
                  Object.entries(prevList).filter(([id]) => id !== key)
                );
            
                // Pass the updated list to removeSimpleList after state update
                updateSimpleLists(editFontSId, updatedList, type);
            
                return updatedList;
              });
        }
    };

    const simpleFontEditPopup = () => {
        let getData = getFontData(editFontSId);
        return(
            <div className="nxtext_simple_font_main_cover">
                <div className='nxtext_field_with_lbl'>
                    <label className='nxtext_secondary_heading'>{__('Font Name', 'nexter-extension')}</label>
                    <input id="text_field_1" className="nxtext_text_field" value={getData?.simplefont?.font_name} type="text" placeholder={__('Enter Font Name', 'nexter-extension')} onChange={(e) => { 
                        setFontName(editFontSId, e.target.value)
                    }}/>
                </div>
                <div className='nxtext_simpfont_text_cover'>
                        {Object.keys(simpleList).map((key, index) => (
                        <>

                            <div className='nxtext_simpfontiner_stripver' key={index.toString()}>
                                <div className="nxtext_simple_font_inner_div">

                                    <div className="nxtext_simple_font_text_select">
                                        <div className="nxtext_file_input">
                                            <label htmlFor={simpleList[key].id || 'simple-font'+key} className="nxtext_file_input_label">{__('--Choose File--', 'nexter-extension')}</label>
                                            <input className="nxtext_file_input_field" id={simpleList[key].id || 'simple-font'+key} value={simpleList[key].filename} type="text" placeholder={__('Upload Your Font', 'nexter-extension')} onClick={(event)=>{openFontUploader(key, 'simple', 'edit')}}/>
                                            <span className="nxtext_file_upload_btn">{ simpleList[key].filename || '' }</span>
                                        </div>
                                        <div className='nxtext_cstm_dropdown' onClick={(e) => { Drop_down_toggle(e) }}>
                                            <div className='nxtext_cstm_dropdown_header'>
                                                <label className='nxt_paragraph' htmlFor="nxt_rollVersion">{ variation_list[simpleList[key].variation]}</label>
                                                <img src={plugin_url + 'assets/svg/nxt_chevron_down.svg'} draggable={false} />
                                            </div>
                                            <div id="nxt_rollVersion" className='nxtext_cstm_dropdown_content'>
                                                {Object.entries(variation_list).map(([id, name]) => (
                                                    <div key={id} className='nxt-option' onClick={(ev) =>{                                                        
                                                            const updateSimpleList = { ...simpleList }
                                                            updateSimpleList[key].variation = id
                                                            setSimpleList(updateSimpleList)
                                                        }} value={id}>{name}</div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="nxtext_simple_font_icon">
                                    <span onClick={()=>{handleRemoveRow(editFontSId, key, 'edit')}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                                            <path stroke="#CCC" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.3" d="M6.385 11.23V6.923m3.23 4.307V6.923M1 3.693h14M11.77 14.46H4.23a1.077 1.077 0 0 1-1.077-1.077V3.692h9.692v9.692a1.076 1.076 0 0 1-1.076 1.077ZM9.615 1.538h-3.23a1.077 1.077 0 0 0-1.078 1.077v1.077h5.385V2.615a1.077 1.077 0 0 0-1.077-1.077Z" />
                                        </svg>
                                    </span>
                                </div>

                            </div>

                        </>
                    ))}
                </div>

                <button className="nxtext_primary_btn" onClick={()=> {handleAddRow(editFontSId, 'edit')} }>{__('Add Variant', 'nexter-extension')}</button>

            </div>
        )
    }

    const variableFontList = (font, id) => {
        const fontName = font.variablefont?.font_name;
        var font_variant = '', variable_font_data = font.variablefont;
        if(variable_font_data && variable_font_data.lists){
            for(const list in variable_font_data.lists){                
                font_variant += (variable_font_data.lists) ? variable_list[list]+', ' : '';                
            }
            font_variant = font_variant.trim().replace(/,\s*$/, '');
        }

        if(fontName){
            return (<div className='nxtext_adobe_scan_border'>
                <div className='nxtext_crd_heading'>
                    <div className='nxtext_secondary_heading'>{ fontName }</div>
                    <div className='nxtext_paragrph'>{ font_variant }</div>
                </div>
                <div className='nxtext_crd_icons'>
                    <span className='nxtext_verysm_ico_pair' onClick={()=>{ handleVFontEdit(id)}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
                            <path stroke="#1717CC" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".917" d="M14.387 2.613a2.102 2.102 0 0 0-2.987.02L3.023 11.01 2 15l3.99-1.023 8.377-8.378a2.101 2.101 0 0 0 .02-2.986Z" />
                        </svg>
                    </span>
                    <span style={{ paddingTop: '3px' }}>|</span>
                    <span className='nxtext_verysm_ico_pair' onClick={(e)=>{ handleFontDelete(e, id) }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
                            <path stroke="#1A1A1A" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".917" d="M7 11.75V7.416m3 4.334V7.416m-8-3.25h13M12 15H5a.962.962 0 0 1-.707-.317A1.13 1.13 0 0 1 4 13.917v-9.75h9v9.75c0 .287-.105.563-.293.766A.963.963 0 0 1 12 15ZM10 2H7a.963.963 0 0 0-.707.317A1.13 1.13 0 0 0 6 3.083v1.084h5V3.083c0-.287-.106-.563-.293-.766A.963.963 0 0 0 10 2Z" />
                        </svg>
                    </span>
                </div>
            </div>)
        }
    }

    const setVariableList = (editFontVId, key, att) => {
        for (let i = 0; i < enabledSettings['custom-upload-font'].values.length; i++) {
          if (enabledSettings['custom-upload-font'].values[i].hasOwnProperty(editFontVId)) {            
            const updatedSettings = { ...enabledSettings };
            enabledSettings['custom-upload-font'].values[i][editFontVId].variablefont.lists[key].filename = att.filename;
            enabledSettings['custom-upload-font'].values[i][editFontVId].variablefont.lists[key].id = att.id;
            setEnabledSettings(updatedSettings);
          }
        }
    };

    const variableFontAddPopup = () => {
        return(
            <div className="nxtext_varfont_main_cover">
                <div className='nxtext_field_with_lbl'>
                    <div className='nxtext_field_card_h_strip'>
                        <div className='nxtext_h_with_tip'>
                            <label htmlFor='ProID' className='nxtext_secondary_heading'>Font Name</label>
                            {/* <div className='nxtext_tooltip'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>
                            <span className="nxtext_tooltiptext">Tooltip text</span>
                        </div> */}
                        </div>
                    </div>
                    <input id="ProID" className="nxtext_text_field" value={defaultVariable[VariableUniId].variablefont.font_name} type="text" placeholder={__('Enter Font Name', 'nexter-extension')} onChange={(e)=> {
                        const updatedefaultVar = { ...defaultVariable }
                        updatedefaultVar[VariableUniId].variablefont.font_name = e.target.value
                        setDefaultVariable(updatedefaultVar)
                    }}/>
                </div>
                <div className="nxtext_Variable_font_inner_div">
                    { defaultVariable[VariableUniId]?.variablefont?.lists && Object.keys(defaultVariable[VariableUniId]?.variablefont?.lists).map((key, index) => (                        
                        <div className='nxtext_fileinputs_grp nxtext_field_with_lbl' key={index.toString()}>
                            <label className='nxtext_secondary_heading' htmlFor="italic-file-upload">{ variable_list[key]}</label>
                            <div className="nxtext_file_input">
                                <label htmlFor="italic-file-upload" className="nxtext_file_input_label">{__('--Choose File--', 'nexter-extension')}</label>
                                <input type="text" id="italic-file-upload" className="nxtext_file_input_field" onClick={()=>{openFontUploader(key, 'variable', 'add')}}/>
                                <span className="nxtext_file_upload_btn">{ defaultVariable[VariableUniId]?.variablefont?.lists[key].filename }</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    const variableFontEditPopup = () => {
        let getData = getFontData(editFontVId);
        return(
            <div className="nxtext_varfont_main_cover">
                <div className='nxtext_field_with_lbl'>
                    <div className='nxtext_field_card_h_strip'>
                        <div className='nxtext_h_with_tip'>
                            <label htmlFor='ProID' className='nxtext_secondary_heading'>{__('Font Name', 'nexter-extension')}</label>
                            {/* <div className='nxtext_tooltip'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>
                            <span className="nxtext_tooltiptext">Tooltip text</span>
                        </div> */}
                        </div>
                    </div>
                    <input id="ProID" className="nxtext_text_field" value={getData?.variablefont?.font_name} type="text" placeholder={__('Enter Font Name', 'nexter-extension')} onChange={(e) => { setVFontName(editFontVId, e.target.value) }}/>
                </div>
                <div className="nxtext_Variable_font_inner_div">
                    { getData?.variablefont?.lists && Object.keys(getData?.variablefont?.lists).map((key, value) => (                        
                        <div className='nxtext_fileinputs_grp nxtext_field_with_lbl'>
                            <label className='nxtext_secondary_heading' htmlFor="italic-file-upload">{variable_list[key]}</label>
                            <div className="nxtext_file_input">
                                <label htmlFor="italic-file-upload" className="nxtext_file_input_label">{__('--Choose File--', 'nexter-extension')}</label>
                                <input type="text" id="italic-file-upload" className="nxtext_file_input_field" onClick={()=>{openFontUploader(key, 'variable', 'edit')}}/>
                                <span className="nxtext_file_upload_btn">{ getData?.variablefont?.lists[key].filename }</span>
                            </div>
                        </div>
                    ))}

                </div>                
            </div>
        )
    }

    const keys = SettingData.map(item => item.key);

    const tooltipSVG = <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>

    const viewResetUrl = `${nxtext_ajax_object?.site_url}/?reset-view=${encodeURIComponent(nxtext_ajax_object?.username)}`;

    return (
        <div className='nxtext_extopt_cover_main nxtext_main_container'>
            <div className='nxtext_section_heading_cover'>
                <h3 className='nxtext_primary_heading'>{__('Utilities', 'nexter-extension')}</h3>
            </div>

            <div className='nxtext_field_card_sec_cover'>
            {SettingData.map((setting, index) => (
                    <div className='nxtext_field_card' key={setting.key}>
                        <div className='nxtext_card_top_detail'>
                            <div className='nxtext_field_card_h_strip'>
                                <div className='nxtext_h_with_tip'>
                                    <label htmlFor={`nxt_${setting.key}`} className='nxtext_secondary_heading'>{setting.name}</label>
                                    {setting.isNew &&
                                        <div className="nxt-new-ext">{ __( "NEW", 'nexter-extension' ) }</div>
                                    }
                                    {setting.isBeta &&
                                        <div className="nxt-new-ext">{ __( "BETA", 'nexter-extension' ) }</div>
                                    }
                                    <div className='nxtext_tooltip'>{tooltipSVG}
                                        <span className="nxtext_tooltiptext">{setting.popDesc}</span>
                                    </div>
                                </div>
                                <div className='nxtext_tgl_with_setting'>
                                    {setting.popDesc && (setting.showSetting !=false || (setting.popshow == true && nxtext_ajax_object.pro && (setting.isFreemium || setting.isPro))) &&
                                        <button className={'nxt-ex-btn' + ((enabledSettings && enabledSettings[setting.key] && enabledSettings[setting.key].switch === true) ? ' enabled' : '')} disabled={(enabledSettings && enabledSettings[setting.key] && enabledSettings[setting.key].switch == true) ? false : true} onClick={() => handleOpenPopup(setting)}>{nxtds_icons.setting}</button>
                                    }

                                    <div className="nxtext_block_tgl_btn_cover">
                                        <input className="nxtext_toggle_btn" id={`nxt_${setting.key}`} type="checkbox" checked={(enabledSettings && enabledSettings[setting.key] && enabledSettings[setting.key].switch === true  && ( (nxtext_ajax_object.pro && setting.isPro) || !setting.isPro )) ? true : false} onChange={(e) => {( extensionInstall && ((!setting.isPro) || (nxtext_ajax_object.pro && setting.isPro))) ? handleCheckboxChange(e, setting.key, "extra") : ''}} onClick={() => { if (!extensionInstall) { setIsPopupExtensionInstall(prev => !prev)}else if (!nxtext_ajax_object.pro && setting.isPro) { setIsPopupProVisible(prev => !prev)} } }  />
                                        <label className={"nxtext_switch_label"+(((!nxtext_ajax_object.pro && setting.isPro) || !extensionInstall) ? ' nxt-pro-lock-toggle' : '')} htmlFor={`nxt_${setting.key}`}>
                                            <span className="nxtext_switch_button"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <p className='nxtext_paragrph'>
                                {setting.desc}
                                {setting.link && <a href={setting.link.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>{setting.link.text}</a>}
                            </p>
                            {setting.doclink && !(nxtext_ajax_object?.dashData?.whiteLabel?.nxt_help_link == 'on') &&
                                <div className='nxtext_links_cover'>
                                    {/* <a target="_blank" rel="noopener noreferrer" href='#' className='nxtext_tertiary_btn'>{__('Live Demo', 'nexter-extension')}</a> <span>|</span> */}
                                    <a target="_blank" rel="noopener noreferrer" href={setting.doclink ||'#'} className='nxtext_tertiary_btn nxtext_paragraph'>{__('Read Docs', 'nexter-extension')}</a>
                                </div>
                            }
                        </div>
                        {!nxtext_ajax_object.pro && setting.isPro &&
                            <div className="nxt-beta-ext">{ __( "PRO", 'nexter-extension' ) }</div>
                        }
                        {!nxtext_ajax_object.pro && setting.isFreemium &&
                            <div className="nxt-beta-ext">{ __( "Freemium", 'nexter-extension' ) }</div>
                        }
                       { setting.key == 'regenerate-thumbnails' &&
                            <div className="nxt-beta-ext">{__('Beta', 'nexter-extension')}</div>
                       } 
                    </div>
            ))}
            </div>

            {isPopupVisible &&

                <div>
                    <>
                        <div className='nxtext_overlay' onClick={handleClosePopup}></div>
                        <div className='nxtext_settings_popup'>
                            <svg className='nxtext_close_icon' draggable={false} onClick={handleClosePopup} xmlns="http://www.w3.org/2000/svg" width="36" height="17" fill="none" viewBox="0 0 36 17"><path fill="#414B5A" d="M22.2 4.30665c-.26-.26-.68-.26-.94 0L18 7.55998l-3.26-3.26c-.26-.26-.68-.26-.94 0-.26.26-.26.68 0 .94l3.26 3.26L13.8 11.76c-.26.26-.26.68 0 .94.26.26.68.26.94 0L18 9.43998 21.26 12.7c.26.26.68.26.94 0 .26-.26.26-.68 0-.94l-3.26-3.26002 3.26-3.26c.2533-.25333.2533-.68 0-.93333Z" /></svg>


                            <div className='nxtext_popup_heading'>
                                {(simpleFont || simpleFontEdit) && !isContentDisabled && (
                                    <h3 className='nxtext_primary_heading'>{__('Simple Font Upload', 'nexter-extension')}</h3>
                                )}

                                {(variableFont || variableFontEdit) && !isContentDisabled && (
                                    <h3 className='nxtext_primary_heading'>{__('Variable Font Upload', 'nexter-extension')}</h3>
                                )}
                                { isContentDisabled &&
                                    <h3 className='nxtext_primary_heading'>{popupData.name}</h3>
                                }
                                <p className='nxtext_paragrph' dangerouslySetInnerHTML={{ __html: popupData.popDesc }}></p>

                                {/* {popupData.poplink && <a href={popupData.poplink.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>{popupData.poplink.text}</a>} */}

                            </div>
                            <div className='nxtext_popup_inner_main_co'>
                                {Object.keys(popupData.formField).map((key) => {
                                    const field = popupData.formField[key];

                                    if(key == 'label'){
                                        return
                                    }

                                    return (
                                        <div className='nxtext_field_card_cover' key={field} id={field}>

                                            <div className='nxtext_field_card_bottom'>

                                                {field === 'adobe-font' && (
                                                    <Fragment>
                                                    <div className='nxtext_popup_inner_co'>
                                                        <div className='nxtext_crd_head_strip'>
                                                            <label htmlFor={key} className='nxtext_secondary_heading'>{__('Project ID', 'nexter-extension')}</label>
                                                        </div>
                                                        <input id={key} className="nxtext_text_field" type="text" placeholder={__('Enter Project ID', 'nexter-extension')} value={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values.project_id) ? enabledSettings[field].values.project_id : ''} onChange={(e)=>{
                                                            const updatedSettings = { ...enabledSettings };
                                                            updatedSettings[field].values['project_id'] = e.target.value;
                                                            setEnabledSettings(updatedSettings);
                                                        }}/>
                                                    </div>
                                                    {adobeFontGet()}
                                                    </Fragment>
                                                )}

                                                {field === 'custom-upload-font' && (

                                                    <div className='nxtext_ctm_upver'>
                                                        {isContentDisabled && (
                                                            <div className='nxtext_adobe_scan_main_cover'>
                                                                <div className='nxtext_adobe_scan_text_btn'>
                                                                    <div className='nexter_adobe_scan_inner'>
                                                                    {enabledSettings['custom-upload-font'] && enabledSettings['custom-upload-font'].values && 
                                                                        enabledSettings['custom-upload-font'].values.map((font) => {
                                                                            let unID = Object.keys(font)[0];
                                                                            return Object.values(font).map((f) => {
                                                                                return simpleFontList(f, unID);
                                                                            });
                                                                        })
                                                                    }
                                                                    </div>
                                                                    <div>
                                                                        <button className='nxtext_primary_btn float_right' onClick={handleFontUpload}>{__('Simple Font Upload', 'nexter-extension')}</button>
                                                                    </div>
                                                                </div>
                                                                <div className='nxtext_adobe_scan_text_btn'>
                                                                    <div className='nexter_adobe_scan_inner'>
                                                                    {enabledSettings['custom-upload-font'] && enabledSettings['custom-upload-font'].values && 
                                                                        enabledSettings['custom-upload-font'].values.map((font) => {
                                                                            let unID = Object.keys(font)[0];
                                                                            return Object.values(font).map((f) => {
                                                                                return variableFontList(f, unID);
                                                                            });
                                                                        })
                                                                    }
                                                                    </div>
                                                                    <div>
                                                                        <button className='nxtext_primary_btn float_left' onClick={handleVarFontUpload}>{__('Variable Font Upload', 'nexter-extension')}</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}


                                                        {simpleFont && !isContentDisabled && (
                                                            simpleFontAddPopup()
                                                        )}

                                                        { simpleFontEdit && !isContentDisabled && (
                                                            simpleFontEditPopup()
                                                        )}


                                                        {variableFont && !isContentDisabled && (
                                                            variableFontAddPopup()
                                                        )}

                                                        {variableFontEdit && !isContentDisabled && (
                                                            variableFontEditPopup()
                                                        )}
                                                    </div>
                                                )}

                                                {field === 'wp-replace-url' && (
                                                    <div className='nxtext_replace_main_cover'>
                                                        <div className='nxtext-replace-inner'>
                                                            <div className='nxtext_repc_inner'>
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <div className='nxtext_field_card_h_strip'>
                                                                        <div className='nxtext_h_with_tip'>
                                                                            <label htmlFor='Old_URL' className='nxtext_secondary_heading'>{__('Old URL/Text', 'nexter-extension')}</label>
                                                                            {/* <div className='nxtext_tooltip'>{tooltipSVG}
                                                                                <span className="nxtext_tooltiptext">Tooltip text</span>
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                    <input id="Old_URL" className="nxtext_text_field" value={replaceOpt[field]['from']} type="text" placeholder={__('http://oldurl.com or old text', 'nexter-extension')} onChange={(e)=> {
                                                                        const updatedSettings = { ...replaceOpt };
                                                                        updatedSettings[field]['from'] = e.target.value;
                                                                        setReplaceOpt(updatedSettings);
                                                                    }}/>
                                                                </div>

                                                                <div className='nxtext_field_with_lbl'>
                                                                    <div className='nxtext_field_card_h_strip'>
                                                                        <div className='nxtext_h_with_tip'>
                                                                            <label htmlFor='NewURL' className='nxtext_secondary_heading'>{__('New URL/Text', 'nexter-extension')}</label>
                                                                            {/* <div className='nxtext_tooltip'>{tooltipSVG}
                                                                                <span className="nxtext_tooltiptext">Tooltip text</span>
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                    <input id="NewURL" className="nxtext_text_field" value={replaceOpt[field]['to']} type="text" placeholder={__('http://newurl.com or new text', 'nexter-extension')} onChange={(e)=> {
                                                                        const updatedSettings = { ...replaceOpt };
                                                                        updatedSettings[field]['to'] = e.target.value;
                                                                        setReplaceOpt(updatedSettings);
                                                                    }}/>
                                                                </div>
                                                            </div>

                                                            <div className="nxtext_replace_checkbox">
                                                                <div className="nxtext_replce_checkbox_cover border_remove_r">
                                                                    <input type="checkbox" id="check1" className="nxtext_text_field checkbox_style" onChange={(e)=> {
                                                                        const updatedSettings = { ...replaceOpt };
                                                                        let yesno = (e.target.checked) ? 'yes' : 'no';
                                                                        updatedSettings[field]['case'] = yesno;
                                                                        setReplaceOpt(updatedSettings);
                                                                    }}/>
                                                                    <label htmlFor="check1" className="nxtext_paragrph">{__('Case Sensitive', 'nexter-extension')}</label>
                                                                </div>
                                                                <div className="nxtext_replce_checkbox_cover border_remove_l">
                                                                    <input type="checkbox" id="check2" className="nxtext_text_field checkbox_style" onChange={(e)=> {
                                                                        const updatedSettings = { ...replaceOpt };
                                                                        let yesno = (e.target.checked) ? 'yes' : 'no';
                                                                        updatedSettings[field]['guid'] = yesno;
                                                                        setReplaceOpt(updatedSettings);
                                                                    }}/>
                                                                    <div className='nxtext_h_with_tip'>
                                                                        <label htmlFor="check2" className="nxtext_paragrph">{__('Replace GUIDs', 'nexter-extension')}</label>
                                                                        <div className='nxtext_tooltip'>{tooltipSVG}
                                                                            <span className="nxtext_tooltiptext"><a href="https://developer.wordpress.org/advanced-administration/upgrade/migrating/#important-guid-note" target="_blank">{__('Important GUID Note', 'nexter-extension')}</a></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='nxtext_field_with_lbl nxtext_urllimit_cover'>
                                                                <div className='nxtext_field_card_h_strip'>
                                                                    <div className='nxtext_h_with_tip'>
                                                                        <label htmlFor='new_url_limit' className='nxtext_secondary_heading'>{__('Search Limit', 'nexter-extension')}</label>
                                                                        <div className='nxtext_tooltip'>{tooltipSVG}
                                                                            <span className="nxtext_tooltiptext">{__('Decrease the value if you face any server timeout.', 'nexter-extension')}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <input id="new_url_limit" className="nxtext_text_field" type="number" value={replaceOpt[field]['limit']} placeholder='Search Limit' onChange={(e)=> {
                                                                    const updatedSettings = { ...replaceOpt };
                                                                    updatedSettings[field]['limit'] = e.target.value;
                                                                    setReplaceOpt(updatedSettings);
                                                                }}/>
                                                            </div>

                                                            <div className='nxtext_field_with_lbl nxtext_tables_cover'>
                                                                <div className='nxtext_field_card_h_strip'>
                                                                    <div className='nxtext_h_with_tip'>
                                                                        <label htmlFor='new_url_limit' className='nxtext_secondary_heading'>{__('Select Tables', 'nexter-extension')}</label>
                                                                        <div className='nxtext_tooltip'>{tooltipSVG}
                                                                            <span className="nxtext_tooltiptext">{__('Select one or more database tables where you want to search and replace text or URLs.', 'nexter-extension')}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='nxtext_setbl_cover_main'>
                                                                    {isLoadingTables ? (
                                                                        <div className='nxtext_select_tabls_cover' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100px'}}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" stroke="#1717CC" viewBox="0 0 38 38">
                                                                                <g fill="none" fillRule="evenodd" strokeWidth="2" transform="translate(1 1)">
                                                                                    <circle cx="18" cy="18" r="18" strokeOpacity=".3"/>
                                                                                    <path d="M36 18c0-9.94-8.06-18-18-18">
                                                                                        <animateTransform attributeName="transform" dur="1s" from="0 18 18" repeatCount="indefinite" to="360 18 18" type="rotate"/>
                                                                                    </path>
                                                                                </g>
                                                                            </svg>
                                                                        </div>
                                                                    ) : (
                                                                        <div className='nxtext_select_tabls_cover' tabIndex={0} onKeyDown={handleKeyDown}>    
                                                                            {Object.entries(wpTables).map(([id, name]) => (
                                                                                <div className={"nxtext_paragrph "+(replaceOpt[field]['tables'].includes(id) ? 'active' : '')} key={id} value={id} onClick={(e) => {
                                                                                    const updatedSettings = { ...replaceOpt };
                                                                                    const index = updatedSettings[field]['tables'].indexOf(e.target.getAttribute('value'));
                                                                                    if (index === -1) {
                                                                                        updatedSettings[field]['tables'].push(e.target.getAttribute('value'));
                                                                                    } else if (index !== -1) {
                                                                                        updatedSettings[field]['tables'].splice(index, 1);
                                                                                    }
                                                                                    setReplaceOpt(updatedSettings);
                                                                                }}>{name}</div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='primary_btn_center'>
                                                            <button className='nxtext_primary_btn' onClick={(e)=>{ replaceButtonClick(e)}}>{processReplace ? <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" stroke="#1717CC" viewBox="0 0 38 38"><g fill="none" fillRule="evenodd" strokeWidth="2" transform="translate(1 1)"><circle cx="18" cy="18" r="18" strokeOpacity=".3"/><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" dur="1s" from="0 18 18" repeatCount="indefinite" to="360 18 18" type="rotate"/></path></g></svg> : __('Dry Run', 'nexter-extension')}</button>
                                                        </div>
                                                        {(replaceMsg) &&
                                                            <div className='nxt-ext-error-message'>{replaceMsg}</div>
                                                        }
                                                    </div>
                                                )}

                                                {field === 'wp-duplicate-post' && (
                                                    <div className='nxtext_duplicate_main_div'>

                                                        <div className='nxtext_duplicate_inner_div'>
                                                            <div className="nxtext_duplicate_radio">
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <div className='nxtext_secondary_heading'>{__('Who Can Duplicate', 'nexter-extension')}</div>
                                                                    <div className='nxtext_who_dupli_cover'>
                                                                        <div className="nxtext_duplicate_radio_div radio_border_remove_r">
                                                                            <input type="radio" id="radio1" value="all_users" name="all-author" className="nxtext_text_field" checked={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values["nxt-duppost-access"] == 'all_users') ? true : false} onClick={()=>{changeDupToggle('all_users', 'nxt-duppost-access', field)}}/>
                                                                            <label htmlFor="radio1" className="nxtext_paragrph">{__('All Users', 'nexter-extension')}</label>
                                                                        </div>

                                                                        <div className="nxtext_duplicate_radio_div radio_border_remove_l">
                                                                            <input type="radio" id="radio2" value="original_user" name="all-author" className="nxtext_text_field" checked={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values["nxt-duppost-access"] == 'original_user') ? true : false} onClick={()=>{changeDupToggle('original_user', 'nxt-duppost-access', field)}}/>
                                                                            <label htmlFor="radio2" className="nxtext_paragrph paragrph_wrap">{__('Original Author', 'nexter-extension')}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="nxtext_duplicate_radio">
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <div className='nxtext_secondary_heading'>{__('Post Date', 'nexter-extension')}</div>
                                                                    <div className='nxtext_who_dupli_cover'>
                                                                        <div className="nxtext_duplicate_radio_div radio_border_remove_r">
                                                                            <input type="radio" id="radio3" value="original_date" name="post-all-author" className="nxtext_text_field" checked={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values["nxt-duppost-date"] == 'original_date') ? true : false} onClick={()=>{changeDupToggle('original_date', 'nxt-duppost-date', field)}}/>
                                                                            <label htmlFor="radio3" className="nxtext_paragrph">{__('Duplicate Time', 'nexter-extension')}</label>
                                                                        </div>

                                                                        <div className="nxtext_duplicate_radio_div radio_border_remove_l">
                                                                            <input type="radio" id="radio4" value="current_date" name='post-all-author' className="nxtext_text_field" checked={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values["nxt-duppost-date"] == 'current_date') ? true : false} onClick={()=>{changeDupToggle('current_date', 'nxt-duppost-date', field)}}/>
                                                                            <label htmlFor="radio4" className="nxtext_paragrph paragrph_wrap">{__('Current Time', 'nexter-extension')}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='nxtext_field_with_lbl'>
                                                                <label htmlFor='postfix_txt' className='nxtext_secondary_heading'>{__('Postfix Text', 'nexter-extension')}</label>
                                                                <input type="text" id="postfix_txt" className="nxtext_text_field" placeholder={__('Enter Postfix Text', 'nexter-extension')} value={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values["nxt-duplicate-postfix"]) ? enabledSettings[field].values["nxt-duplicate-postfix"] : ''} onChange={(e)=>{
                                                                    const updatedSettings = { ...enabledSettings };
                                                                    updatedSettings[field].values['nxt-duplicate-postfix'] = e.target.value;
                                                                    setEnabledSettings(updatedSettings); 
                                                                }}/>
                                                            </div>
                                                        </div>
                                                        <div className='nxtext_duplicate_inner_div'>
                                                            <div className="nxtext_duplicate_radio">
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <div className='nxtext_secondary_heading'>{__('Post Author', 'nexter-extension')}</div>
                                                                    <div className='nxtext_who_dupli_cover'>
                                                                        <div className="nxtext_duplicate_radio_div radio_border_remove_r">
                                                                            <input type="radio" id="radio5" value="current_author" name='ptDate_all_auth' className="nxtext_text_field" checked={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values["nxt-duppost-author"] == 'current_author') ? true : false} onClick={()=>{changeDupToggle('current_author', 'nxt-duppost-author', field)}}/>
                                                                            <label htmlFor="radio5" className="nxtext_paragrph">{__('Current User', 'nexter-extension')}</label>
                                                                        </div>

                                                                        <div className="nxtext_duplicate_radio_div radio_border_remove_l">
                                                                            <input type="radio" id="radio6" value="original_author" name='ptDate_all_auth' className="nxtext_text_field" checked={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values["nxt-duppost-author"] == 'original_author') ? true : false} onClick={()=>{changeDupToggle('original_author', 'nxt-duppost-author', field)}}/>
                                                                            <label htmlFor="radio6" className="nxtext_paragrph paragrph_wrap">{__('Original Author', 'nexter-extension')}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* DropDown Start */}
                                                            <div className='nxtext_field_with_lbl'>
                                                                <div className='nxtext_secondary_heading'>{__('Post Status', 'nexter-extension')}</div>
                                                                <div className='nxtext_cstm_dropdown' onClick={(e) => { Drop_down_toggle(e) }}>
                                                                    <div className='nxtext_cstm_dropdown_header'>
                                                                        <label className='nxt_paragraph' htmlFor="nxt_rollVersion">{selectedPostStatus}</label>
                                                                        <img src={plugin_url + 'assets/svg/nxt_chevron_down.svg'} draggable={false} />
                                                                    </div>
                                                                    <div id="nxt_rollVersion" className='nxtext_cstm_dropdown_content'>
                                                                        <input type="hidden" value={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values["nxt-duppost-status"]) ? enabledSettings[field].values["nxt-duppost-status"] : 'same'}/>
                                                                        {Object.entries(duplicate_post_status).map(([id, name]) => (
                                                                            <div key={id} className='nxt-option' onClick={(ev) => changePostStatus(ev, id, name, field)} value={id}>{name}</div>
                                                                        ))}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* DropDown End */}
                                                            <div className='nxtext_field_with_lbl'>
                                                                <label htmlFor='slug_txt' className='nxtext_secondary_heading'>{__('Slug Text', 'nexter-extension')}</label>
                                                                <input type="text" id="slug_txt" className="nxtext_text_field" placeholder={__('Enter Slug Text', 'nexter-extension')} value={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values["nxt-duplicate-slug"]) ? enabledSettings[field].values["nxt-duplicate-slug"] : ''} onChange={(e)=>{
                                                                    const updatedSettings = { ...enabledSettings };
                                                                    updatedSettings[field].values['nxt-duplicate-slug'] = e.target.value;
                                                                    setEnabledSettings(updatedSettings); 
                                                                }}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {field === 'content-post-order' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        {Object.keys(get_post_list).map((item, index) => (
                                                            <div className='nxtext_strip_tgl_cover' key={index.toString()}>
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={item}>{get_post_list[item]}</label>
                                                                </div>
                                                                <div className='nxtext_tgl_with_setting'>
                                                                    <div className="nxtext_block_tgl_btn_cover">
                                                                        <input className="nxtext_toggle_btn" id={item} type="checkbox" 
                                                                        checked={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field].values.includes(item)) ? true : false} 
                                                                        onClick={()=>{changeArrayToggle(item,'', field)}} />
                                                                        <label className="nxtext_switch_label" htmlFor={item}>
                                                                            <span className="nxtext_switch_button"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {field === 'disable-gutenberg' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        {Object.keys(get_post_list).filter(item => item !== 'attachment' && item !== 'product').map((item, index) => (
                                                            <div className='nxtext_strip_tgl_cover' key={index.toString()}>
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={item}>{get_post_list[item]}</label>
                                                                </div>
                                                                <div className='nxtext_tgl_with_setting'>
                                                                    <div className="nxtext_block_tgl_btn_cover">
                                                                        <input className="nxtext_toggle_btn" id={item} type="checkbox" 
                                                                        checked={(enabledSettings && enabledSettings[field] && enabledSettings[field].values && enabledSettings[field]?.values?.posts?.includes(item)) ? true : false} 
                                                                        onClick={()=>{changeArrayToggle(item,'posts', field)}} />
                                                                        <label className="nxtext_switch_label" htmlFor={item}>
                                                                            <span className="nxtext_switch_button"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        
                                                        <div className='nxtext_strip_tgl_cover' style={{width: "100%"}}>
                                                            <div className='nxtext_strip_tgl_h'>
                                                                <label className='nxtext_paragrph nxt_text_long' htmlFor={'frontend_style'}>{__('Disable Frontend Block Styles', 'nexter-extension')}</label>
                                                                <div className='nxtext_tooltip'>{tooltipSVG}
                                                                    <span className="nxtext_tooltiptext">{__('Remove default Gutenberg block CSS from the frontend of your site for selected types. This helps reduce unnecessary styling or improve page speed if Gutenberg isn’t in use.', 'nexter-extension')}</span>
                                                                </div>
                                                            </div>
                                                            <div className='nxtext_tgl_with_setting'>
                                                                <div className="nxtext_block_tgl_btn_cover">
                                                                    <input className="nxtext_toggle_btn" id={'frontend_style'} type="checkbox" 
                                                                        checked={
                                                                            enabledSettings?.[field]?.values?.frontend_style ? true : false
                                                                        }
                                                                        onClick={(e)=>{changeDupToggle(e.target.checked,'frontend_style', field)}} />
                                                                    <label className="nxtext_switch_label" htmlFor={'frontend_style'}>
                                                                        <span className="nxtext_switch_button"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {field === 'redirect-404-page' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        <div className='nxtext_crd_head_strip'>
                                                            <label htmlFor={key} className='nxtext_secondary_heading'>{__('Redirect to ', 'nexter-extension')}</label>
                                                        </div>
                                                        <input id={key} className="nxtext_text_field" type="text" placeholder={__('Enter Path URL (e.g. new-404-page)', 'nexter-extension')} value={enabledSettings?.[field]?.values || ''} onChange={(e)=>{
                                                            const updatedSettings = { ...enabledSettings };
                                                            updatedSettings[field].values = e.target.value;
                                                            setEnabledSettings(updatedSettings);
                                                        }}/>
                                                        <span>{__('This will be added after your main domain. For example: yoursite.com/page-not-found', 'nexter-extension')}</span>
                                                    </div>
                                                )}
                                                {field === 'public-preview-drafts' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        <div className="nxt-number-field">
                                                        {__('Set how long the preview link stays active','nexter-extension')} <input id="text_field_1" className="nxtext_text_field" value={enabledSettings[field]?.values?.days || 3} type="number" min={1} max={365} step={1} onChange={(e)=> {
                                                            const updatedSettings = { ...enabledSettings };
                                                            if (updatedSettings[field]) {
                                                                updatedSettings[field].values.days = e.target.value;
                                                            }
                                                            setEnabledSettings(updatedSettings);
                                                        }} style={{maxWidth: '60px'}} />{__('days','nexter-extension')}
                                                        <div className='nxtext_tooltip'>{tooltipSVG}
                                                                    <span className="nxtext_tooltiptext">{__('After the set number of days, the preview link will automatically expire for security. ', 'nexter-extension')}</span>
                                                                </div> 
                                                        </div>
                                                        {Object.keys(get_post_list).filter(item => item !== 'attachment').map((item, index) => (
                                                            <div className='nxtext_strip_tgl_cover' key={index.toString()}>
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={item}>{get_post_list[item]}</label>
                                                                </div>
                                                                <div className='nxtext_tgl_with_setting'>
                                                                    <div className="nxtext_block_tgl_btn_cover">
                                                                        <input className="nxtext_toggle_btn" id={item} type="checkbox" 
                                                                        checked={enabledSettings?.[field]?.values?.posts?.includes(item) || false} 
                                                                        onClick={()=>{changeArrayToggle(item, 'posts',  field)}} />
                                                                        <label className="nxtext_switch_label" htmlFor={item}>
                                                                            <span className="nxtext_switch_button"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {field === 'regenerate-thumbnails' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        {Object.keys(regen_thumbneils).map((item, index) => (
                                                            <div className='nxtext_strip_tgl_cover' key={index.toString()}>
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={regen_thumbneils[item]}>{regen_thumbneils[item]}</label>
                                                                </div>
                                                                <div className='nxtext_tgl_with_setting'>
                                                                    <div className="nxtext_block_tgl_btn_cover">
                                                                        <input className="nxtext_toggle_btn" id={regen_thumbneils[item]} type="checkbox" checked={(disable_image_size.includes(regen_thumbneils[item])) ? false : true}/>
                                                                        <label className="nxtext_switch_label" htmlFor={regen_thumbneils[item]}>
                                                                            <span className="nxtext_switch_button"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {field === 'taxonomy-order' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        {Object.entries(get_taxonomy_list)
                                                            .filter(([post_type]) => post_type !== 'attachment')
                                                            .map(([post_type, taxonomies]) =>
                                                                Object.entries(taxonomies).map(([taxonomy_key, taxonomy_label], index) => (
                                                                <div className='nxtext_strip_tgl_cover' key={`${post_type}-${taxonomy_key}`}>
                                                                    <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={`${post_type}-${taxonomy_key}`}>
                                                                        {get_post_list[post_type]}<span className="nxt_label_icon dashicons dashicons-arrow-right-alt2"></span>{taxonomy_label}
                                                                    </label>
                                                                    </div>
                                                                    <div className='nxtext_tgl_with_setting'>
                                                                    <div className="nxtext_block_tgl_btn_cover">
                                                                        <input
                                                                        className="nxtext_toggle_btn"
                                                                        id={`${post_type}-${taxonomy_key}`}
                                                                        type="checkbox"
                                                                        checked={
                                                                            enabledSettings?.[field]?.values?.taxonomy?.includes(taxonomy_key) || false
                                                                        }
                                                                        onClick={() => changeArrayToggle(taxonomy_key, 'taxonomy', field)}
                                                                        />
                                                                        <label className="nxtext_switch_label" htmlFor={`${post_type}-${taxonomy_key}`}>
                                                                        <span className="nxtext_switch_button"></span>
                                                                        </label>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                ))
                                                            )}
                                                    </div>
                                                )}

                                                {field === 'smtp-email' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        <div className="nxtext_field_wrap">
                                                            <div className='nxtext_field_with_lbl'>
                                                                <div className='nxtext_tab_radio_wrap'>
                                                                    <div className="nxtext_radio_inner_div">
                                                                        <input
                                                                            type="radio"
                                                                            id="smtp-radio1"
                                                                            value="gmail"
                                                                            name="smtp-type"
                                                                            className="nxtext_radio_field"
                                                                            checked={
                                                                                enabledSettings?.[field]?.values?.type === 'gmail'
                                                                            }
                                                                            onChange={() => changeDupToggle('gmail', 'type', field)}
                                                                        />
                                                                        <label htmlFor="smtp-radio1" className="nxtext_paragrph">
                                                                            {__('Gmail SMTP', 'nexter-extension')}
                                                                        </label>
                                                                    </div>

                                                                    <div className="nxtext_radio_inner_div">
                                                                        <input
                                                                            type="radio"
                                                                            id="smtp-radio2"
                                                                            value="custom"
                                                                            name="smtp-type"
                                                                            className="nxtext_radio_field"
                                                                            checked={
                                                                                enabledSettings?.[field]?.values?.type === 'custom'
                                                                            }
                                                                            onChange={() => changeDupToggle('custom', 'type', field)}
                                                                        />
                                                                        <label htmlFor="smtp-radio2" className="nxtext_paragrph paragrph_wrap">
                                                                            {__('Custom SMTP', 'nexter-extension')}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {enabledSettings?.[field]?.values?.type === 'gmail' &&
                                                            <>
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label htmlFor='email_txt' className='nxtext_secondary_heading'>{__('From Email', 'nexter-extension')}</label>
                                                                    <input type="text" id="email_txt" className="nxtext_text_field"  value={enabledSettings?.[field]?.values?.email || ''} placeholder={__('Enter From Email ID', 'nexter-extension')} onChange={(e)=>{
                                                                        const updatedSettings = { ...enabledSettings };
                                                                        updatedSettings[field].values.email = e.target.value;
                                                                        delete updatedSettings[field]?.values?.access_token;
                                                                        setEnabledSettings(updatedSettings); 
                                                                        setMessage('');
                                                                        setIsError(false);
                                                                    }} />
                                                                </div>
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label htmlFor='from_name_txt' className='nxtext_secondary_heading'>{__('From Name', 'nexter-extension')}</label>
                                                                    <input type="text" id="from_name_txt" className="nxtext_text_field" placeholder={__('Enter From Name', 'nexter-extension')}  value={enabledSettings?.[field]?.values?.name || ''} onChange={(e)=>{
                                                                        const updatedSettings = { ...enabledSettings };
                                                                        updatedSettings[field].values.name = e.target.value;
                                                                        delete updatedSettings[field]?.values?.access_token;
                                                                        setEnabledSettings(updatedSettings); 
                                                                        setMessage('');
                                                                        setIsError(false);
                                                                    }} />
                                                                </div>
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label htmlFor='client_id' className='nxtext_secondary_heading'>{__('Client ID', 'nexter-extension')}</label>
                                                                    <input type="text" id="client_id" className="nxtext_text_field" placeholder={__('Enter Google Client ID', 'nexter-extension')} value={enabledSettings?.[field]?.values?.gclient_id || ''} onChange={(e)=>{
                                                                        const updatedSettings = { ...enabledSettings };
                                                                        updatedSettings[field].values.gclient_id = e.target.value;
                                                                        delete updatedSettings[field]?.values?.access_token;
                                                                        setEnabledSettings(updatedSettings); 
                                                                        setMessage('');
                                                                        setIsError(false);
                                                                    }} />
                                                                    <div className="nxtext_paragrph">{__('Enable Gmail API and Generate Client ID and Secret ID from Google Cloud Platform. Click Here to ', 'nexter-extension')}<a href={'https://console.cloud.google.com/apis/credentials'} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'blink', color: 'var(--nxtext-blue)' }}>{__('Generate.')}</a></div>
                                                                </div>
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label htmlFor='secret_id' className='nxtext_secondary_heading'>{__('Client Secret', 'nexter-extension')}</label>
                                                                    <input type="password" id="secret_id" className="nxtext_text_field" placeholder={__('Enter Google Client Secret', 'nexter-extension')} autoComplete="new-password" value={enabledSettings?.[field]?.values?.gsecret_key || ''} onChange={(e)=>{
                                                                        const updatedSettings = { ...enabledSettings };
                                                                        updatedSettings[field].values.gsecret_key = e.target.value;
                                                                        delete updatedSettings[field]?.values?.access_token;
                                                                        setEnabledSettings(updatedSettings); 
                                                                        setMessage('');
                                                                        setIsError(false);
                                                                    }}/>
                                                                </div>
                                                                {nxtext_ajax_object?.smtp_url &&
                                                                    <div className='nxtext_field_with_lbl'style={{ position: 'relative'}}>
                                                                        <label htmlFor='redirect_url' className='nxtext_secondary_heading'>{__('Redirect URI', 'nexter-extension')}</label>
                                                                        <input type="text" id="redirect_url" className="nxtext_text_field readonly" disabled ref={redirectInputRef} value={nxtext_ajax_object?.smtp_url || ''} />
                                                                        <button
                                                                            type="button"
                                                                            className="nxtext_copy_btn"
                                                                            onClick={copyRedirectURL}
                                                                            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                                                            title="Copy Redirect URI"
                                                                            >
                                                                            {copied ? (
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                                                                <path fill="#2e8b57" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29 5.7 12.7a.996.996 0 1 1 1.41-1.41L10 14.17l6.88-6.88a.996.996 0 1 1 1.41 1.41l-7.59 7.59a.996.996 0 0 1-1.41 0z" />
                                                                                </svg>
                                                                            ) : (
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" fill="none" viewBox="0 0 12 13"><g stroke="#1A1A1A" strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)"><path d="M10 5.294H5.5a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1H10a1 1 0 0 0 1-1v-4.5a1 1 0 0 0-1-1Z"/><path d="M2.5 8.294H2a1 1 0 0 1-1-1v-4.5a1 1 0 0 1 1-1h4.5a1 1 0 0 1 1 1v.5"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 .794h12v12H0z"/></clipPath></defs></svg>
                                                                            )}
                                                                            </button>
                                                                    </div>
                                                                }
                                                            </>
                                                            }
                                                            {enabledSettings?.[field]?.values?.type === 'custom' &&
                                                            <>
                                                                {/* From Email */}
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label htmlFor='custom_from_email' className='nxtext_secondary_heading'>{__('From Email', 'nexter-extension')}</label>
                                                                    <input type="email" id="custom_from_email" className="nxtext_text_field"
                                                                    placeholder={__('Enter From Email ID', 'nexter-extension')}
                                                                    value={enabledSettings?.[field]?.values?.custom?.from_email || ''}
                                                                    onChange={(e) => handleChange('from_email', e.target.value, field)}
                                                                    />
                                                                </div>
                                                                {/* From Name */}
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label htmlFor='custom_from_name' className='nxtext_secondary_heading'>{__('From Name', 'nexter-extension')}</label>
                                                                    <input type="text" id="custom_from_name" className="nxtext_text_field"
                                                                    placeholder={__('Enter From Name', 'nexter-extension')}
                                                                    value={enabledSettings?.[field]?.values?.custom?.from_name || ''}
                                                                    onChange={(e) => handleChange('from_name', e.target.value, field)}
                                                                    />
                                                                </div>
                                                                {/* SMTP Host */}
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label htmlFor='host' className='nxtext_secondary_heading'>{__('SMTP Host', 'nexter-extension')}</label>
                                                                    <input type="text" id="host" className="nxtext_text_field"
                                                                    placeholder={__('Enter SMTP Host', 'nexter-extension')}
                                                                    value={enabledSettings?.[field]?.values?.custom?.host || ''}
                                                                    onChange={(e) => handleChange('host', e.target.value, field)}
                                                                    />
                                                                </div>
                                                                {/* SMTP Port */}
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label htmlFor='port' className='nxtext_secondary_heading'>{__('SMTP Port', 'nexter-extension')}</label>
                                                                    <input type="number" id="port" className="nxtext_text_field"
                                                                    placeholder={__('Enter SMTP Port', 'nexter-extension')}
                                                                    value={enabledSettings?.[field]?.values?.custom?.port || ''}
                                                                    onChange={(e) => handleChange('port', e.target.value, field)}
                                                                    />
                                                                </div>
                                                                {/* Encryption */}
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label className='nxtext_secondary_heading'>
                                                                        {__('Encryption', 'nexter-extension')}
                                                                    </label>

                                                                    <div className='nxtext_radio_wrap'>
                                                                        {['none', 'ssl', 'tls'].map((option, index) => (
                                                                        <div className="nxtext_radio_btn_wrap" key={option}>
                                                                            <input
                                                                            type="radio"
                                                                            id={`smtp-encryption-${index}`}
                                                                            value={option}
                                                                            name="smtp-encryption"
                                                                            className="nxtext_radio__field"
                                                                            checked={enabledSettings?.[field]?.values?.custom?.encryption === option}
                                                                            onChange={(e) => handleChange('encryption', e.target.value, field)}
                                                                            />
                                                                            <label htmlFor={`smtp-encryption-${index}`} className="nxtext_paragrph">
                                                                            {option.toUpperCase()}
                                                                            </label>
                                                                        </div>
                                                                        ))}
                                                                    </div>
                                                                    </div>

                                                                {/* Auto TLS */}
                                                                <div className='nxtext-toggle-flex'>
                                                                    <div className='nxtext_strip_tgl_cover' key={'auto_tls'}>
                                                                        <div className='nxtext_strip_tgl_h'>
                                                                            <label className='nxtext_paragrph' htmlFor={'auto_tls'}>{__('Auto TLS', 'nexter-extension')}</label>
                                                                            <div className='nxtext_tooltip'>{tooltipSVG}
                                                                                <span className={"nxtext_tooltiptext"}>{__('By default, TLS encryption is automatically used if the server supports it.', 'nexter-extension')}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className='nxtext_tgl_with_setting'>
                                                                            <div className="nxtext_block_tgl_btn_cover">
                                                                                <input className="nxtext_toggle_btn" id={'auto_tls'} type="checkbox" onChange={(e) => handleChange('autoTLS', e.target.checked, field)} checked={!!enabledSettings?.[field]?.values?.custom?.autoTLS} />
                                                                                <label className="nxtext_switch_label" htmlFor={'auto_tls'}>
                                                                                    <span className="nxtext_switch_button"></span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    {/* Authentication */}
                                                                    <div className='nxtext_strip_tgl_cover' key={'auth'}>
                                                                        <div className='nxtext_strip_tgl_h'>
                                                                            <label className='nxtext_paragrph' htmlFor={'auth'}>{__('Authentication', 'nexter-extension')}</label>
                                                                            <div className='nxtext_tooltip'>{tooltipSVG}
                                                                                <span className={"nxtext_tooltiptext"}>{__('By default, TLS encryption is automatically used if the server supports it.', 'nexter-extension')}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className='nxtext_tgl_with_setting'>
                                                                            <div className="nxtext_block_tgl_btn_cover">
                                                                                <input className="nxtext_toggle_btn" id={'auth'} type="checkbox" onChange={(e) => handleChange('auth', e.target.checked, field)} checked={!!enabledSettings?.[field]?.values?.custom?.auth} />
                                                                                <label className="nxtext_switch_label" htmlFor={'auth'}>
                                                                                    <span className="nxtext_switch_button"></span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                
                                                                {/* SMTP Username */}
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label htmlFor='username' className='nxtext_secondary_heading'>{__('SMTP Username', 'nexter-extension')}</label>
                                                                    <input type="text" autoComplete="new-username" id="username" className="nxtext_text_field"
                                                                    placeholder={__('Enter SMTP Username', 'nexter-extension')}
                                                                    value={enabledSettings?.[field]?.values?.custom?.username || ''}
                                                                    onChange={(e) => handleChange('username', e.target.value, field)}
                                                                    />
                                                                </div>

                                                                {/* SMTP Password */}
                                                                <div className='nxtext_field_with_lbl'>
                                                                    <label htmlFor='smtp_password' className='nxtext_secondary_heading'>{__('SMTP Password', 'nexter-extension')}</label>
                                                                    <input type="password" autoComplete="new-password" id="smtp_password" className="nxtext_text_field"
                                                                    placeholder={__('Enter SMTP Password', 'nexter-extension')}
                                                                    value={enabledSettings?.[field]?.values?.custom?.password || ''}
                                                                    onChange={(e) => handleChange('password', e.target.value, field)}
                                                                    />
                                                                </div>
                                                            </>
                                                            }
                                                        </div>
                                                        <div className='nxtext_field_with_lbl'>
                                                            {((enabledSettings?.[field]?.values?.type=='gmail' && enabledSettings?.[field]?.values?.access_token && enabledSettings?.[field]?.values?.email) || (enabledSettings?.[field]?.values?.type=='custom' && enabledSettings?.[field]?.values?.custom?.connect)) &&
                                                                <div className='nxt-send-mail-wrap'>
                                                                    <div className='nxtext_field_with_lbl'>
                                                                        <label htmlFor='send_to' className='nxtext_secondary_heading'>{__('Send Test Email', 'nexter-extension')}</label>
                                                                        <div className='send-mail-inner'>
                                                                        <input type="email" id="send_to" className="nxtext_text_field"
                                                                        placeholder={__('Type email here to check SMTP', 'nexter-extension')}
                                                                        value={sendMailTo || ''}
                                                                        onChange={(e) => setSendMailTo(e.target.value || '')}
                                                                        />
                                                                        <button className="nxt-send-test-email" onClick={(e) => smtpSendMail(e, enabledSettings?.[field]?.values?.type)}>
                                                                        {
                                                                            sendMailProcess === 'loader' ? (
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" stroke="#1717CC" viewBox="0 0 38 38"><g fill="none" fillRule="evenodd" strokeWidth="2" transform="translate(1 1)"><circle cx="18" cy="18" r="18" strokeOpacity=".3" /><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" dur="1s" from="0 18 18" repeatCount="indefinite" to="360 18 18" type="rotate" /></path></g></svg>
                                                                            ) : sendMailProcess === 'success' ? (
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="#2e8b57" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29 5.7 12.7a.996.996 0 1 1 1.41-1.41L10 14.17l6.88-6.88a.996.996 0 1 1 1.41 1.41l-7.59 7.59a.996.996 0 0 1-1.41 0z"/></svg>
                                                                            ) : sendMailProcess === 'failed' ? (
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="#e53935" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/></svg>
                                                                            ) : (
                                                                                __('Send', 'nexter-extension')
                                                                            )
                                                                        }
                                                                        </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            { msgType == enabledSettings?.[field]?.values?.type && message && 
                                                                <div className={isError ? 'nxt-ext-error-message' : 'nxt-ext-success-message'}>{message}</div>
                                                            }
                                                        </div>
                                                    </div>
                                                )}

                                                {field === 'view-admin-role' && (
                                                    <div className='nxt-view-admin-role-wrap'>
                                                        <img src={nxtext_ajax_object.nxtex_url + 'assets/images/view-admin-role.png'} className='view-admin-role-img' />
                                                        <div className='nxtext_paragrph'>{__('Please refresh the page to see your settings in the admin bar.', 'nexter-extension')}</div>
                                                        <div className='nxt-display-notice'>
                                                            <b>{__('Notice :', 'nexter-extension')}</b>
                                                            {__('If you lose access to your administrator account, recover it by visiting: ', 'nexter-extension')}
                                                            <a
                                                            href={viewResetUrl} target="_blank" rel="noopener noreferrer" >{viewResetUrl}</a>
                                                            <div>
                                                            <b>{__('Important :', 'nexter-extension')}</b>{' '}
                                                            {__('If you\'re using', 'nexter-extension')} <b>{__('Ninja Firewall', 'nexter-extension')}</b>,
                                                            {__(' ensure the option "Block attempts to gain administrative privileges" is unchecked in Firewall Policies before switching to a non-admin role. This prevents accidental lockouts from your admin account.', 'nexter-extension')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className={'nxtext_popup_bottom '+((replaceorelse == 'regenerate-thumbnails') ? 'regenerate-thumb-btn' : '')}>
                                {!simpleFont && !variableFont && !simpleFontEdit && !variableFontEdit && (
                                    <a className='nxtext_tertiary_btn' target="_blank" rel="noopener noreferrer" href={popupData.doclink}>{__('Read How it Works', 'nexter-extension')}</a>
                                )}

                                {(variableFont || simpleFont || simpleFontEdit || variableFontEdit) && !isContentDisabled && (
                                    <div>
                                        <a className='nxtext_tertiary_btn' onClick={handleBack}>{__('Back', 'nexter-extension')}</a>
                                    </div>
                                )}
                                { ((replaceorelse == 'custom-upload-font' && (simpleFont || variableFont || simpleFontEdit || variableFontEdit)) || replaceorelse != 'custom-upload-font' && replaceorelse != 'smtp-email' && replaceorelse != 'view-admin-role') &&
                                    <button className={"nxtext_blue_common_btn "+((replaceorelse != 'wp-replace-url' || (replaceorelse == 'wp-replace-url' && replaceFind)) ? '' : 'disable-confirm-btn')} onClick={(e)=>{handlePopupSave(e)}} disabled={(replaceorelse != 'wp-replace-url') ? false : (replaceFind ? false : true)}>{(replaceorelse != 'wp-replace-url') ? (replaceorelse == 'regenerate-thumbnails') ? __('Regenerate', 'nexter-extension') : __('Save', 'nexter-extension') : __('Confirm', 'nexter-extension')}</button>
                                }
                                {replaceorelse == 'smtp-email' && enabledSettings?.['smtp-email']?.values?.type=='gmail' &&
                                    <button className={"nxtext_blue_common_btn"+ (enabledSettings?.['smtp-email']?.values?.access_token ? ' smtp-connected' : '')} onClick={(e) => {(!enabledSettings?.['smtp-email']?.values?.access_token ? smtpAuthGmail(e) : '')} }>{isGProcess ? isGProcess : ((enabledSettings?.['smtp-email']?.values?.access_token) ? '✓ Authorized' : __('Authorize with Gmail', 'nexter-extension'))}</button>
                                }
                                {replaceorelse == 'smtp-email' && enabledSettings?.['smtp-email']?.values?.type=='custom' &&
                                    <button className={"nxtext_blue_common_btn"+ (enabledSettings?.['smtp-email']?.values?.custom?.connect ? ' smtp-connected' : '')} onClick={(e) => {(!enabledSettings?.['smtp-email']?.values?.custom?.connect ? smtpAuthCustom(e) : '')} }>{isCProcess ? isCProcess : ((enabledSettings?.['smtp-email']?.values?.custom?.connect) ? '✓ Authorized' : __('Connect SMTP', 'nexter-extension'))}</button>
                                }
                            </div>
                        </div>
                    </>
                </div>
            }
            {isPopupProVisible &&
                <ProNotice isPopupVisible={isPopupProVisible} setIsPopupVisible={setIsPopupProVisible} />
            }
            {isPopupExtensionInstall &&
                <ExtensionInstallPopup isPopupExtensionInstall={isPopupExtensionInstall} setIsPopupExtensionInstall={setIsPopupExtensionInstall} />
            }
        </div >
    );
}

export default Settings;